import React, { useState, useEffect, useContext, useRef } from 'react';
import {
    List, Datagrid, TextField, Create, SimpleForm, TextInput, FunctionField, SimpleList, SelectInput,
    Toolbar as RaToolbar, SaveButton, Edit, useRedirect,
    Button as RaButton, useInput, useRefresh, usePermissions, useRecordContext, BulkDeleteButton, DateInput, EditButton
} from 'react-admin';
import {
    Typography, useMediaQuery, makeStyles, Avatar, withStyles, Button, Dialog, DialogContent, FormControl, Select, MenuItem,
    DialogActions, Switch, TextField as MuiTextField, CircularProgress, DialogTitle, Portal, FormControlLabel, InputLabel, Checkbox, RadioGroup, Radio, Link as MuiLink, Grid, Box, FormLabel
} from '@material-ui/core';
import CustomDatePicker from './components/CustomDatePicker';
import moment from "moment";
import { customTheme } from "./customTheme";
import { vehicleSvgs, fastagIssuers, hideMobileNumber as hideMobileMask, hideName, hideVehicleNumber } from "./sharedData";
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { translate, crudUpdate } from 'ra-core';
import config from "./config.json";
// import DisplayColumnsButton from './components/DisplayColumnsButton';
import RaAutocompleteInput from './components/RaAutocompleteInput';
import queryString from 'query-string';
import CustomExportButton from './components/CustomExportButton';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import RaCheckBoxInput from './components/RaCheckBoxInput';
import PaymentIcon from '@material-ui/icons/Payment';
import { Helmet } from "react-helmet";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { useHistory } from "react-router-dom";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import RaGenderInput from './components/RaGenderInput';
import RaGenderField from './components/RaGenderField';
import CustomCreateButton from './components/CustomCreateButton';
import ScrollableTable from './components/ScrollableTable';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch } from 'react-redux';
// import ParkSmartLogo from "./images/logo.png";
import ParkSmartTag from './images/parksmartTag.png'
import RaDateInput from './components/RaDateInput';
import CustomFilter from './components/CustomFilter';
import CustomSearch from './components/CustomSearch';
import FasTagCard from './images/fastagCard.png';
import { Link, useLocation } from 'react-router-dom';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ParkingSearchSelector from './components/ParkingSearchSelector'
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ContextProvider } from './globalContextProvider';
import CustomPagination from './components/CustomPagination';
// import VisibilityIcon from '@material-ui/icons/Visibility';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";
import DateTimePickerToolbar from "./components/DateTimePickerToolbar";
import BeenhereIcon from '@material-ui/icons/Beenhere';
import BeenhereOutlinedIcon from '@material-ui/icons/BeenhereOutlined';
import PrivacyPasswordAuthentication from './components/CustomPrivacyPasswordAuth';
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined';
import Skeleton from '@material-ui/lab/Skeleton';
import LockIcon from '@material-ui/icons/Lock';
import CustomRfidInventorySelector from './components/CustomRfidInventorySelector';
import CustomCompanySelector from './components/CustomCompanySelector';
// import CustomSelectDropDown from './components/CustomSelectDropDown';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import notify from './components/CustomUseNotify';
import CustomDeleteButton from './CustomDeleteButton';
import UserVehicles from './components/UserVehicles';
import { CustomEditButton } from './MonthlyPass';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 350
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 5px 10px",
    },
    input: {
        width: "500px"
    },
    MuiInputBase: {
        root: {
            width: "800px"
        }
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    },
});

const RFID_COLUMNS = {
    "Parking Name": false,
    "RFID": false,
    "Name": true,
    "Mobile": true,
    "Vehicle Number": true,
    "Type": true,
    "Model": true,
    "User Type": true,
    "Sub Type": true,
    "Tag": true,
    "Surface ID": true,
    "Issue Date": true,
    "Start Date": true,
    "Validity": true,
    "Last Recharge": true,
    "Amount": true,
    "Company": true,
    "Tower": true,
    "Flat Number": true,
    "Parking Slots": true,
    "Additional Information": false
};

const getFastagIssuerId = (tagId) => {
    if (RegExp("^918907048").test(tagId)) {
        return "607417";
    } else {
        let tagIdBin = "";
        for (let i = 0; i < tagId.length; i++) {
            tagIdBin += (parseInt(tagId[i], 16).toString(2)).padStart(4, "0");
        }
        const issuerId = parseInt(tagIdBin.substr(43, 20), 2).toString();
        return issuerId;
    }
};

const renderVehicleType = row => (
    row.vehicle_type ?
        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8 }} alt={row.vehicle_type_label} />
            {/* row.vehicle_type_label */}
        </div>
        :
        null
);
// const renderDate = date => moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
// const renderTagImage = record => {
//     let fix = record["rfid"] ? record["rfid"] : ""
//     const issuerId = getFastagIssuerId(fix);
//     const issuer = fastagIssuers[issuerId] ? fastagIssuers[issuerId] : null;

//     if (typeof issuer === "string")
//         return <img src={`/images/${issuer.replace(/\s/g, "")}.png`} alt={issuer} style={{ width: 100, borderRadius: 10, border: "1px solid #aaa" }} />
//     else if (typeof record.tag_id === "string" && record.tag_id !== "")
//         return <img src={ParkSmartTag} alt="ParkSmart" style={{ width: 100, borderRadius: 10, display: "block", margin: "auto" }} />
//     else
//         return <div style={{ textAlign: "center" }}>-</div>
// };

const renderTagImageDataGrid = record => {
    if (!record) return '-'
    if (record && (record['rfid'] == null || record['rfid'] === '')) return '-'

    let fix = record["rfid"] ? record["rfid"] : ""
    const issuerId = getFastagIssuerId(fix);
    const issuer = fastagIssuers[issuerId] ? fastagIssuers[issuerId] : null;
    if (typeof issuer === "string") {
        return <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img src={`/images/${issuer.replace(/\s/g, "")}.png`} alt={issuer} style={{ width: 75, borderRadius: 5, border: "1px solid #aaa" }} />
        </div>
    }
    else if (typeof record.tag_id === "string" && record.tag_id !== "") {
        return <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img src={ParkSmartTag} alt="ParkSmart" style={{ width: 75, borderRadius: 5, display: "block", margin: "auto" }} />
        </div>
    }
    else
        return "-"
};

const renderTagImageForMob = record => {
    if (!record) return '-'
    if (record && (record['rfid'] == null || record['rfid'] === '')) return '-'

    let fix = record["rfid"] ? record["rfid"] : ""
    const issuerId = getFastagIssuerId(fix);
    const issuer = fastagIssuers[issuerId] ? fastagIssuers[issuerId] : null;

    if (typeof issuer === "string")
        return <div><span style={{ color: "#5a5a5a" }}>Tag: </span>{issuer}</div>
    else if (typeof record.tag_id === "string" && record.tag_id !== "")
        return <div><span style={{ color: "#5a5a5a" }}>Tag: </span>ParkSmart</div>
    else
        return <div><span style={{ color: "#5a5a5a" }}>Tag: </span>-</div>
};

const renderTagImagee = rfid => {
    if (!rfid) return '-'
    if (rfid && (rfid == null || rfid === '')) return '-'

    const issuerId = getFastagIssuerId(rfid);
    const issuer = fastagIssuers[issuerId] ? fastagIssuers[issuerId] : null;

    if (typeof issuer === "string")
        return <img src={`/images/${issuer.replace(/\s/g, "")}.png`} alt={issuer} style={{ width: 100, borderRadius: 10, border: "1px solid #aaa" }} />
    else if (typeof rfid === "string" && rfid !== "")
        return <img src={ParkSmartTag} alt="ParkSmart" style={{ width: 100, borderRadius: 10, display: "block", margin: "auto" }} />
    else
        return <div style={{ textAlign: "center" }}>-</div>
};

// const renderTagImageForPermit = record => {
//     const issuerId = getFastagIssuerId(record);
//     const issuer = fastagIssuers[issuerId] ? fastagIssuers[issuerId] : null;

//     if (typeof issuer === "string")
//         return <img src={`/images/${issuer.replace(/\s/g, "")}.png`} alt={issuer} style={{ width: 100, borderRadius: 10, border: "1px solid #aaa" }} />
//     else if (typeof record.tag_id === "string" && record.tag_id !== "")
//         return <img src={ParkSmartTag} alt="ParkSmart" style={{ width: 100, borderRadius: 10, display: "block", margin: "auto" }} />
//     else
//         return <div style={{ textAlign: "center" }}>-</div>
// };

const getSearchState = (searchObj) => {
    let newSearch = []
    for (let i in searchObj) {
        if (searchObj[i].showSearch) {
            newSearch.push(searchObj[i].name)
        }
    }
    return newSearch
}

const renderValidity = (record) => {
    if (!record.limit_validity) {
        return { style: { color: "#e99100", backgroundColor: "#e9910019" }, value: { status: "Unlimited", date: "" } }
    }
    else if (record.valid_till && record.limit_validity && record.valid_till > moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59")) {
        return { style: { color: "#18cc69", backgroundColor: "#18cc6919" }, value: { status: "Active", date: moment(record.valid_till).utcOffset("+05:30").format("DD/MM/YYYY") } }
    }
    else if (record.valid_till && record.limit_validity && moment(record.valid_till).utcOffset("+05:30").add(record.recharge_grace_period, 'days').format("YYYY-MM-DD 23:59:59") > moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59")) {
        return { style: { color: "#109cf1", backgroundColor: "#109cf119" }, value: { status: `Grace Period`, date: moment(record.valid_till).utcOffset("+05:30").format("DD/MM/YYYY") } }
    }
    else if (record.valid_till && record.limit_validity && moment(record.valid_till).utcOffset("+05:30").add(record.recharge_grace_period, 'days').format("YYYY-MM-DD 23:59:59") < moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59")) {
        return { style: { color: "#de575e", backgroundColor: "#de575e19" }, value: { status: `Inactive`, date: moment(record.valid_till).utcOffset("+05:30").format("DD/MM/YYYY") } }
    }
    else if (record.valid_till && record.limit_validity && record.user_type === 'resident' && record.valid_till < moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59")) {
        return { style: { color: "#de575e", backgroundColor: "#de575e19" }, value: { status: `Inactive`, date: moment(record.valid_till).utcOffset("+05:30").format("DD/MM/YYYY") } }
    }
    else if (record.valid_till && record.limit_validity && record.user_type !== 'resident' && record.valid_till < moment().utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss")) {
        return { style: { color: "#de575e", backgroundColor: "#de575e19" }, value: { status: `Inactive`, date: moment(record.valid_till).utcOffset("+05:30").format("DD/MM/YYYY") } }
    }
    else {
        return { style: { color: "#de575e", backgroundColor: "#de575e19" }, value: { status: `-`, date: "-" } }
    }
}

// const renderVehicleNumber = (record) => {
//     if (record.vehicle_number) {
//         return <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: 5 }}>
//             <div>
//                 <p style={{ lineHeight: "0px" }}>{record.vehicle_number}</p>
//                 <p style={{ lineHeight: "8px", color: "#BDBDBD", fontSize: 11, width: 78, overflow: "hidden", textOverflow: "ellipsis" }}>{record.chassis_number ? record.chassis_number : "-"}</p>
//             </div>
//             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#EBEFF2" }}>
//                 <ExpandMoreIcon style={{ color: "#334D6E" }} />
//             </div>
//         </div>
//     }
// }

// const renderSelector = (record) => {
//     let userVehicles = []
//     if (record && record.vehicle_number) {
//         userVehicles.push({ id: record.id, value: record.vehicle_number, subValue: record.chassis_number, vehicleData: record })
//     }
//     if (record && record.secondary_users) {
//         let secondaryUsers = JSON.parse(record.secondary_users)
//         if (secondaryUsers[0].id !== null && secondaryUsers[0].id !== "null") {
//             secondaryUsers.map((user) => userVehicles.push({ id: user.id, value: user.vehicle_number, subValue: user.chassis_number, vehicleData: user }))
//         }
//     }
//     return <CustomSelectDropDown
//         itemsArray={userVehicles}
//     />
// }

const renderVehicles = (record, searchId, searchEndpoint = "secondaryVehicles") => {
    return <UserVehicles
        record={record}
        searchId={searchId}
        searchEndpoint={searchEndpoint}
    />
}

export const NewRfidDataList = props => {
    const classes = useStyles();
    const location = useLocation();
    const refresh = useRefresh();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const { permissions } = usePermissions();
    const listDataRef = useRef();

    const queryParams = queryString.parse(props.location.search)
    const [prevSearch] = useState(queryParams && queryParams.mobile ? { inputSearch: queryParams.mobile, type: "Mobile" } : sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : "")
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [allowDelete] = useState(sessionStorage.getItem("allow_rfid_delete") === "1");
    const [showRfidColumn] = useState(sessionStorage.getItem("show_rfid_column") === "1");
    const [showTagColumn] = useState(sessionStorage.getItem("show_tag_column") === "1");
    const [showValidityColumn] = useState(sessionStorage.getItem("show_validity_column") === "1");
    const [allowCreate] = useState(sessionStorage.getItem("allow_rfid_create") === "1");
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    const [showCompany] = useState(sessionStorage.getItem("show_rfid_company") === "1");
    const [showReserved] = useState(sessionStorage.getItem("show_reserved_column") === "1");
    const [showFlatDetails] = useState(sessionStorage.getItem("show_flat_details") === "1");
    const [showRfidRecharge] = useState(sessionStorage.getItem("show_rfid_recharge") === "1");
    const [hideMobileNumber] = useState(sessionStorage.getItem("hide_mobile_number") === "1");
    const [showExitVehicleButton] = useState(sessionStorage.getItem("show_exit_vehicle_button") === "1");
    // const [companyUser] = useState(sessionStorage.getItem("company_user") === "1");
    const [showOnboardUsers] = useState(sessionStorage.getItem("show_onboard_users") === "1");
    //const [vehicleTypes, setVehicleTypes] = React.useState(Object.keys(featuresData.vehicle_type).map(type => ({ type, label: featuresData.vehicle_type[type].label, name: featuresData.vehicle_type[type].name })));
    const [displayColumns, setDisplayColumns] = useState(localStorage.getItem("rfidColumns") ? JSON.parse(localStorage.getItem("rfidColumns")) : RFID_COLUMNS);
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    //let valueByFilterInitState = [{ filterType: "Organization", value: "", id: "" }, { filterType: "Vehicle", value: "", id: "" }, { filterType: "Parking Name", value: "", id: "" }, { filterType: "Parking Zones", value: "", id: "" }]
    
    const [privacyFeatureAccess, setPrivacyFeatureAccess] = useState(sessionStorage.getItem('privacy_feature_access') === "1")
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchStateObject = [
        { name: "Vehicle Number", showSearch: true },
        { name: "Rfid", showSearch: showRfidColumn },
        { name: "Name", showSearch: true },
        { name: "Mobile", showSearch: true },
        { name: "Tag ID", showSearch: showTagColumn },
        { name: "Tower Name", showSearch: (showFlatDetails || permissions === "admin") },
        { name: "Flat Number", showSearch: (showFlatDetails || permissions === "admin") },
        { name: "Additional Information", showSearch: true },
    ]
    let searchTypeState = getSearchState(searchStateObject)
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
    const [accessKey, setAccessKey] = useState(null);
    const handleAccessKey = (data) => {
        // Update state with the fetched data
        setAccessKey(data);
      };
    let filterTypesInitState = [
        {
            resourcePath: "rfidOrganization",
            filterType: "Organization",
            dataList: [],
            searchList: [],
            listType: "Dynamic",
            resourceParam: "name",
            source: "organization",
            showFilter: showCompany
        },
        {
            filterType: "Vehicle",
            dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Locked & Unlocked",
            dataList: [{ name: "Locked", id: 1 }, { name: "Unlocked", id: 0 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Enable & Disable",
            dataList: [{ name: "Enable", id: 1 }, { name: "Disable", id: 0 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Display Columns",
            dataList: { "Parking Name": false, "RFID": false },
            listType: "CheckboxStatic",
            caseType: "CheckboxTypeStatic",
            showFilter: true,
            filterFormat: "Checkbox"
        },

    ]
    const [settingFilterFormat, setSettingFilterFormat] = useState({})
    const filter = { ...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));


    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
    const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

    const renderTime = time => {
        const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if (use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").utcOffset("+05:30").format(`DD/MM/YYYY HH:mm${secondsFormat}`);
        return moment(time, "YYYY-MM-DD HH:mm:ss").utcOffset("+05:30").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
    };


    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };
	
	const reportParams = {
        access_key_ids: accessKey ? [accessKey] : undefined,
        report_name: "PERMIT_USERS",
        report_format: "xlsx",
        start_time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        end_time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        filters: filter,
    };

    const getExportFile = (fileType) => {
        const {current : {total, currentSort, filterValues}} = listDataRef
        const params = {
            filter: JSON.stringify({ displayColumns, ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/v2/rfidData?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `${currentParking && currentParking.name ? currentParking.name : ""} Permit Users Data.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    const getPDF = () => {
        getExportFile("pdf");
    };

    const BulkActionButtons = (props) => {
        const [open, setOpen] = React.useState(false);
        const [isRechargeAble, setIsRechargeAble] = React.useState(true);
        const [amount, setAmount] = useState("");
        const [accessKeyId, setAccessKeyId] = useState("")
        //const notify = useNotify();

        const handleClickOpen = () => {
            setOpen(true);
        };

        const handleClose = () => {
            setOpen(false);
        };

        const getAmount = () => {
            if (props.selectedIds.length !== 0) {
                fetch(`${config.HOST_NAME}/crm/v3/rfidAmountRequest`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        rfIds: props.selectedIds
                    }),
                })
                    .then(response => {
                        saveTokens(response)
                        return response.json()
                    })
                    .then(json => {

                        if (json.success) {
                            let data = json.data
                            let totalBulkAmount = 0
                            let access_key_id = data[0].access_key_id
                            for (let i in data) {

                                if (!data[i].limit_validity) {
                                    setIsRechargeAble(false)
                                    //notify("Cannot Recharge this permit", "info");
                                    return;
                                }

                                if (access_key_id !== data[i].access_key_id) {
                                    setIsRechargeAble(false)
                                    notify("Cannot Recharge for different parkings", "info");
                                    return;
                                }

                                if (props.selectedIds.length === 1) {
                                    if (data[i].primary_permit_id) {
                                        setIsRechargeAble(false)
                                        notify(`Please recharge your primary vehicle ${data[i].vehicle_number} instead`, "info");
                                        return;
                                    }
                                } if (props.selectedIds.length > 1) {
                                    if (data[i].primary_permit_id) {
                                        setIsRechargeAble(false)
                                        notify(`Secondary Permit found in Bulk Recharge. Please remove it`, "info");
                                        return;
                                    }
                                }
                                //parking flag
                                if (true) {
                                    console.log(data[i])
                                    console.log(moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59"))
                                    if (data[i].valid_till > moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59")) {
                                        setIsRechargeAble(false)
                                        notify(`Please kindly recharge after ${moment(data[i].valid_till).utcOffset("+05:30").format("DD-MM-YYYY")}`, "info");
                                        return;
                                    }
                                }
                                totalBulkAmount += data[i].amount
                            }
                            setAmount(totalBulkAmount)
                            setAccessKeyId(access_key_id)
                            setIsRechargeAble(true)
                        } else {
                            notify(json.message, "warning");
                        }
                    })
                    .catch(error => {
                        notify("Something went wrong", "warning");
                        console.log(error);
                    });
            }
        }
        React.useEffect(() => {

            if (props.selectedIds.length !== 0) {
                getAmount()
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [props.selectedIds])

        return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", columnGap: 1 }} >
            {(!viewOnly || showRfidRecharge) && showValidityColumn && isRechargeAble && <RechargeButton label="Recharge" record={{ ids: props.selectedIds }} amount={amount} accessKeyId={accessKeyId} setAmount={(val) => setAmount(val)} />}

            {!viewOnly && !(sessionStorage.getItem("company_user") === "1" && sessionStorage.getItem("rfid_validity_default") === "1") && <>
                {
                    props.selectedIds.length === 1 ? <Link to={`/rfidData/${props.selectedIds[0]}`} style={{ textDecoration: "none" }}>
                        <RaButton label="EDIT" color="primary"><EditIcon /></RaButton></Link> :
                        <RaButton label="EDIT" color="primary" disabled={true}><EditIcon /></RaButton>
                }
            </>}

            {/* <RaButton label="EDIT" color="primary" disabled={props.selectedIds.length !== 1}>
                <Link to={`/rfidData/${props.selectedIds[0]}`} style={{ textDecoration: "none", color: props.selectedIds.length === 1 ? "#18cc69" : "#00000042" }}>
                    <EditIcon style={{ fontSize: "18px" }} /></Link></RaButton> */}

            {/* {allowDelete && <DeleteButton mutationMode="pessimistic" />} */}
            {/* {allowDelete && <BulkDeleteButton {...props} undoable={true} />} */}

            {allowDelete && <div>
                <RaButton label='DELETE' style={{ color: customTheme.palette.error.main }} onClick={handleClickOpen}>
                    <DeleteIcon />
                </RaButton>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    fullWidth
                    classes={{ paper: classes.dialogPaper }}
                >
                    <DialogTitle id="alert-dialog-title">{"Use Google's location service?"}</DialogTitle>
                    <div style={{ width: "100%" }}>
                        <SimpleForm toolbar={false}>
                            <div style={{ paddingTop: "10px" }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <Box>
                                        <p style={{ fontSize: 15, fontWeight: "500", color: "black" }}>Are you sure you want to <strong>Delete</strong> these Rfids.</p>
                                    </Box>
                                </div>
                            </div>
                        </SimpleForm>

                    </div>

                    <DialogActions style={{ padding: "22px 35px" }}>

                        <Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                            Cancel
                        </Button>
                        <BulkDeleteButton style={{ backgroundColor: customTheme.palette.error.main, color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} {...props} undoable={true} />
                    </DialogActions>
                </Dialog>
            </div>}

        </div>
    }

    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Organization") {
                    values = { ...values, organization: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Vehicle") {
                    values = { ...values, vehicle_type: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
                if (filterListValue[val].filterType === "Locked & Unlocked") {
                    values = { ...values, lock_type: filterListValue[val].id === 1 || filterListValue[val].id === 0 ? filterListValue[val].id : undefined }
                } if (filterListValue[val].filterType === "Enable & Disable") {
                    values = { ...values, enabled_type: filterListValue[val].id === 1 || filterListValue[val].id === 0 ? filterListValue[val].id : undefined }
                }
                if (filterListValue[val].filterType === "Display Columns") {
                    values = { ...values, columns: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]);

    React.useEffect(() => {
        const displayColumnsKeys = Object.keys(displayColumns);
        const columnKeys = Object.keys(RFID_COLUMNS);
        let isOutdated = false;
        for (let i in columnKeys) {
            if (displayColumnsKeys[i] !== columnKeys[i]) {
                isOutdated = true;
            }
        }
        if (isOutdated) {
            const temp = { ...RFID_COLUMNS };
            for (let column in RFID_COLUMNS) {
                if (displayColumns[column] === false) {
                    temp[column] = false;
                }
            }
            setDisplayColumns(temp);
            // localStorage.setItem("terminalColumns", JSON.stringify(temp));
        } else {
            // localStorage.setItem("terminalColumns", JSON.stringify(displayColumns));
        }
    }, [displayColumns]);

    React.useEffect(() => {
        const queryParams = queryString.parse(props.location.search);
        if (queryParams.parking)
            setCurrentParking(JSON.parse(queryParams.parking));
    }, [props]);

    return <div className={classes.list} >
        <Helmet>
            <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
        </Helmet>

        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter && <ParkingSearchSelector
                value={currentParking}
                onChange={onParkingChange}
                clearable={true}
                pathName={location.pathname}
            />}

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomFilter handleAccessKey={handleAccessKey} filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} defaultColumns={RFID_COLUMNS} storageKey="rfidColumns" displayColumns={displayColumns} setDisplayColumns={setDisplayColumns} />
            {!viewOnly && hideMobileNumber && <PrivacyPasswordAuthentication privacyFeatureAccess={privacyFeatureAccess} setPrivacyFeatureAccess={setPrivacyFeatureAccess} />}
            {!viewOnly && showOnboardUsers && <Link to={`/rfidData/onboardUsers`} style={{ textDecoration: "none" }}>
                <Button className="customCreateBtnStyle" title='Import'>
                    <FileCopyIcon fontSize='small' />
                </Button>
            </Link>}
            {!viewOnly && props.hasCreate && allowCreate && <CustomCreateButton label="Create User" basePath={props.basePath} resource={props.resource} />}
            <CustomExportButton getCSV={getExcelFile} getPDF={getPDF} reportParams={reportParams} disabled={listDataRef.current && listDataRef.current.total === 0} />
        </div>
        
        <List
            {...props}
            title="RFID Data"
            style={{ marginTop: 20}}
            bulkActionButtons={<BulkActionButtons />}
            sort={{ field: 'registration_date', order: 'DESC' }}
            exporter={false}
            filter={filter}
            empty={false}
            actions={false}
            pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}} />}
        >
            {isSmallDevice ?
                <SimpleList
                    leftIcon={row => row.vehicle_type ? <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ padding: 4, width: 28, height: 28, marginTop: 8, marginRight: 10 , overflow:"visible"}} /> : undefined}
                    primaryText={record => hideVehicleNumber(record["vehicle_number"])}
                    secondaryText={record => (<div>
                        {displayColumns["RFID"] && showRfidColumn && <div style={{ color: "#444" }}>{record["rfid"]}</div>}
                        {displayColumns["Parking Name"] && <div style={{ color: customTheme.palette.secondary.main }}>{record["parking_name"]}</div>}
                        {displayColumns["Name"] && record.name && <div><span style={{ color: "#5a5a5a" }}>Name: </span>{hideName(record.name)}</div>}
                        {/* {hideMobileNumber && privacyFeatureAccess === null ? <div><span style={{ color: "#5a5a5a" }}>Mob No: </span>{record.mobile.slice(0, -4)}**** <PrivacyPasswordAuthentication privacyFeatureAccess={privacyFeatureAccess} setPrivacyFeatureAccess={setPrivacyFeatureAccess} /></div> : <div><span style={{ color: "#5a5a5a" }}>Mob No: </span>{record.mobile}</div>} */}
                        {displayColumns["Mobile"] && hideMobileNumber && privacyFeatureAccess === null ? 
                            <FunctionField source="mobile" label="Mobile No." render={record => {
                                return record["mobile"] !== null ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}><span style={{ color: "#5a5a5a", marginRight: 5 }}>Mob No: </span>{hideMobileMask(record["mobile"])}</div> : ""
                            }} />
                        :
                            <FunctionField source="mobile" label="Mobile No." render={record => record["mobile"] !== null ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}><span style={{ color: "#5a5a5a", marginRight: 5 }}>Mob No: </span>{`${hideMobileMask(record["mobile"])}`}</div> : ""} />
                        }
                        {displayColumns["Chassis Number"] && record.chassis_number !== "null" && <div><span style={{ color: "#5a5a5a" }}>Chassis No: </span>{record.chassis_number}</div>}
                        {displayColumns["Model"] && record.brand && record.model && <div><span style={{ color: "#5a5a5a" }}>Model: </span>{record.brand} {record.model}</div>}
                        {displayColumns["Flat Number"] && (!showCompany || showFlatDetails || permissions === "admin") && <div>{record["society_flat_number"] ? `Flat No: ${record["society_flat_number"]}` : ""}</div>}
                        {displayColumns["Tower"] && (!showCompany || showFlatDetails || permissions === "admin") && <div>{record["society_tower_name"] ? `Tower: ${record["society_tower_name"]}` : ""}</div>}
                        {displayColumns["Parking Slots"] && (!showCompany || showFlatDetails || permissions === "admin") && record.parking_slots && record.parking_slots.length > 0 && <div><span style={{ color: "#5a5a5a" }}>Slots: </span>{record.parking_slots.join(", ")}</div>}
                        {displayColumns["Issue Date"] && <div><span style={{ color: "#5a5a5a" }}>Issue Date: </span>{renderTime(record["created_on"])}</div>}
                        {displayColumns["Start Date"] && <div><span style={{ color: "#5a5a5a" }}>Start Date: </span>{renderTime(record["registration_date"])}</div>}
                        {/* <div><span style={{ color: "#5a5a5a" }}>Validity: </span>{showValidityColumn && record["valid_till"] && record["limit_validity"] ? `${renderTime(record["valid_till"])}` : "Unlimited"}</div> */}
                        {displayColumns["Validity"] && showValidityColumn && <FunctionField
                            source="valid_till"
                            label="Validity"
                            render={record => {
                                let recordResult = renderValidity(record)
                                return <div style={{ margin: "6px 0px" }}>
                                    <div style={{ color: "#5a5a5a" }}>Validity: <span style={{ ...recordResult.style, padding: "1px 8px", borderRadius: 500 }}>{recordResult.value.status} {record.valid_till && record.limit_validity ? `- ${recordResult.value.date}` : ""}</span></div>
                                </div>
                            }}
                        />}
                        {displayColumns["Last Recharge"] && showValidityColumn && <div><span style={{ color: "#5a5a5a" }}>Last Recharge: </span>{showValidityColumn && record["update_on"] && record["update_on"] ? `${renderTime(record["update_on"])}` : "-"}</div>}
                        {displayColumns["Amount"] && showValidityColumn && <div>{record["amount"] ? `Amount: ${record["amount"]}` : ""}</div>}
                        {displayColumns["Company"] && (showCompany || permissions === "admin") && record.organization && <div><span style={{ color: "#5a5a5a" }}>Company Name: </span>{record.organization}</div>}
                        {displayColumns["Tag"] && showTagColumn && <FunctionField label="Tag" render={renderTagImageForMob} />}
                        {displayColumns["Surface ID"] && showTagColumn && <div>{record["tag_id"] ? `Surface ID: ${record["tag_id"]}` : ""}</div>}
                        {displayColumns["Additional Information"] && record.additional_info && <div><span style={{ color: "#5a5a5a" }}>Additional Info: </span>{record.additional_info}</div>}

                        {!viewOnly && <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <FunctionField label='Status' source='enabled' render={record => record.user_type === "resident" && record.enabled === 1 ? <CustomScheduleApprovalButton record={record} label="Status" source="enabled" disabled={viewOnly} /> : <CustomApprovalButton record={record} label="Status" source="enabled" disabled={viewOnly} />} />
                            {(permissions === 'admin' || showExitVehicleButton) && <ExitVehicleButton {...props} record={record} disabled={viewOnly} />}
                            {(showReserved || permissions === "admin") && <CustomReserveButton {...props} label="Reserve" source="reserved" record={record} disabled={viewOnly} />}

                            {!viewOnly && !(sessionStorage.getItem("company_user") === "1" && sessionStorage.getItem("rfid_validity_default") === "1") && record.monthly_pass_id ? <CustomEditButton {...props} record={record} /> : <EditButton {...props} record={record} />}
                            {allowDelete && record.monthly_pass_id ? <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/monthlyPass'} /> :  <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/v2/rfidData'} />}
                        </div>}
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid className={!viewOnly ? 'rfidDataGrid' : ''} component={ScrollableTable} >
                    <FunctionField label={false} source='enabled' render={record => record && record.user_type === "resident" && record.enabled === 1 ? <CustomScheduleApprovalButton record={record} label="Status" source="enabled" disabled={viewOnly} /> : record && <CustomApprovalButton record={record} label="Status" source="enabled" disabled={viewOnly} />} />
                    <RaGenderField source="gender" label="" />
                    {displayColumns["Name"] && <FunctionField source='name' label='Name' render={(record) => record && record.name ? hideName(record.name) : '-'} />}
                    {/* <FunctionField label="Name" source='name' render={(record) => record && <p> {record.name}</p>} /> */}
                    {displayColumns["Mobile"] && hideMobileNumber && privacyFeatureAccess === null ? <FunctionField source="mobile" label="Mobile No." render={record => {
                        return record ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>{record && record.mobile ? hideMobileMask(record["mobile"]) : "-"}</div> : "-"
                    }} />
                        : <FunctionField source="mobile" label="Mobile No." render={record => record && record.mobile ? hideMobileMask(record["mobile"]) : "-"} />
                    }
                    {/* <FunctionField source="vehicle_number" label="Vehicle Number" render={record => record && record.vehicle_number && renderSelector(record)} /> */}
                    {displayColumns["Vehicle Number"] && <FunctionField source="vehicle_number" label="Vehicle Number" render={record => record && record.vehicle_number && renderVehicles(record, record.id)} />}
                    {displayColumns["Type"] &&
                        <FunctionField
                            source="vehicle_type"
                            label="Type"
                            render={record => record && renderVehicleType(record)}
                            sortable
                        />
                    }
                    {displayColumns["Model"] && <FunctionField source="brand" label="Model" render={record => record && record.brand && record.model ? `${record.brand} ${record.model}` : "Unknown"} />}
                    {displayColumns["User Type"] && <FunctionField source="user_type" label="User Type" render={record => record && record.user_type ? record.user_type : "-"} />}
                    {displayColumns["Sub Type"] && <FunctionField source="user_sub_type" label="User Sub Type" render={record => record && record.user_sub_type ? record.user_sub_type : "-"} />}
                    {displayColumns["Tag"] && showTagColumn && <FunctionField label="Tag" render={record => record && renderTagImageDataGrid(record)} />}
                    {displayColumns["Surface ID"] && showTagColumn && <FunctionField source="tag_id" label="Surface ID" render={record => record && record.tag_id ? record.tag_id : "-"} />}
                    {showRfidColumn && displayColumns["RFID"] && <FunctionField source="rfid" label="RFID" render={record => record && record.rfid ? record.rfid : "-"} />}
                    {displayColumns["Issue Date"] && <FunctionField source="created_on" label="Issue Date" render={record => record && record["created_on"] ? renderTime(record["created_on"]) : record && renderTime(record["registration_date"]) ? renderTime(record["registration_date"]) : "-"} sortable={true} />}
                    {displayColumns["Start Date"] && <FunctionField source="registration_date" label="Start Date" render={record => record && renderTime(record["registration_date"])} sortable={true} />}
                    {displayColumns["Validity"] && showValidityColumn && <FunctionField
                        source="valid_till"
                        label="Validity"
                        render={record => {
                            let recordResult = renderValidity(record)
                            return record ? <div style={{ textAlign: "center", whiteSpace: "normal" }}>
                                <div
                                    className={classes.chipCell}
                                    style={{ ...recordResult.style, marginBottom: "5px" }}
                                >
                                    {recordResult.value.status}
                                </div>
                                {record.valid_till && record.limit_validity ? `${recordResult.value.date}` : ""}
                            </div> : "-"
                        }}
                        style={{ display: "flex", justifyContent: "center" }}
                    />}
                    {displayColumns["Last Recharge"] && showValidityColumn && <FunctionField source="update_on" label="Last Recharge" render={record => record && record["update_on"] && record["update_on"] ? renderTime(record["update_on"]) : "-"} />}
                    {displayColumns["Amount"] && showValidityColumn && <FunctionField source="amount" label="Amount" render={record => record && record["amount"] != null && record["limit_validity"] ? `₹${parseFloat(record["amount"])}` : "-"} sortable={true} />}
                    {displayColumns["Company"] && (showCompany || permissions === "admin") && <TextField source='organization' label="Company" />}
                    {displayColumns["Tower"] && (!showCompany || showFlatDetails || permissions === "admin") && <FunctionField source="society_tower_name" label="Tower" style={{ textTransform: "capitalize" }} render={record => record && record.society_tower_name ? record.society_tower_name : "-"} />}
                    {displayColumns["Flat Number"] && (!showCompany || showFlatDetails || permissions === "admin") && <FunctionField source="society_flat_number" label="Flat Number" style={{ textTransform: "capitalize" }} render={record => record && record.society_flat_number ? record.society_flat_number : "-"} />}
                    {displayColumns["Parking Slots"] && (!showCompany || showFlatDetails || permissions === "admin") && <FunctionField source="parking_slots" label="Parking Slots" style={{ textTransform: "capitalize" }} render={record => record && record.parking_slots && record.parking_slots.length > 0 ? record.parking_slots.join(", ") : "-"} />}
                    {displayColumns["Additional Information"] && <FunctionField source="additional_info" label="Additional Information" render={record => record && record["additional_info"] ? record["additional_info"] : "-"} />}
                    {displayColumns["Parking Name"] && <TextField source="parking_name" label="Parking Name" />}

                    {/* {(!viewOnly || showRfidRecharge) && showValidityColumn && <RechargeButton label="Recharge" />} */}
                    {/* {showRfidRecharge && <RechargeButton label="Recharge" />} */}
                    {/* {!viewOnly && <EditButton />} */}
                    {/* {allowDelete && <DeleteButton mutationMode="pessimistic" />} */}
                    {permissions === 'admin' && <PermitSyncStatus />}
                    <FunctionField source="locked" label={false} render={record => record && record.locked ? <LockIcon color="error" style={{ fontSize: 27 }} /> : <LockOpenOutlinedIcon color="primary" style={{ fontSize: 27 }} />} />
                    {!viewOnly && <FunctionField className="ListIconsContainerRfidData" render={record => record &&
                        <div className="ListIcons">
                            {(showReserved || permissions === "admin") && <CustomReserveButton {...props} label={false} source="reserved" record={record} disabled={viewOnly} />}
                            <div>
                               {!(sessionStorage.getItem("company_user") === "1" && sessionStorage.getItem("rfid_validity_default") === "1") && record.monthly_pass_id ? <CustomEditButton {...props} record={record} /> : <EditButton {...props} title="Edit" label={false} record={record} />}
                            </div>
                            <div>
                            {allowDelete && record.monthly_pass_id ? <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={record.monthly_pass_id ? 'v3/monthlyPass' : 'v3/v2/rfidData'} /> :  <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/v2/rfidData'} />}
                            </div>
                            {(permissions === 'admin' || showExitVehicleButton) && <ExitVehicleButton {...props} record={record} disabled={viewOnly} />}
                        </div>
                    } />}
                </Datagrid>
            }
        </List>
    </div >
};

const PermitSyncStatus = (props) => {
    const { isSmallDevice } = props;
    const record = useRecordContext(props);
    //const notify = useNotify();

    const [loading, setLoading] = useState(true);
    const [result, setResult] = useState(null)

    React.useEffect(() => {
        fetch(`${config.HOST_NAME}/crm/v3/rfidSyncStatus?rfid_id=${record.id}&access_key_id=${record.access_key_id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false);
                if (json.success) {
                    setResult(json.data)
                } else {
                    notify(json.message, 'warning');
                }
            })
            .catch((error) => {
                setLoading(false);
                notify('Error Fetching Permit Sync Status', 'warning');
            });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!record) return null

    return (<div style={{ display: isSmallDevice ? "block" : "flex", justifyContent: "center", alignItems: "center" }}>
        {loading ?
            <Skeleton variant="text" height={18} width={20} style={{ display: "inline-block", transform: "none" }} />
            :
            <>
                {
                    result && result.rfidSyncedON > 0 && result.devicesAtParking > 0 ?
                        renderCircularProgress(result)
                        : <CircularProgressWithLabel content={<CloseIcon style={{ fontSize: 15, color: "#de575e", marginTop: 5 }} />} />
                }
            </>
        }</div>
    );
};

const renderCircularProgress = ({ rfidSyncedON, devicesAtParking }) => {
    let progress = (rfidSyncedON / devicesAtParking) * 100
    return <CircularProgressWithLabel value={~~progress} content={~~progress === 100 ? <CheckIcon style={{ display: ~~progress === 100 ? "inline-block" : "none", fontSize: 15, color: "#18cc69", marginTop: 5 }} /> : <p style={{ fontSize: 7 }}>{~~progress}%</p>} />
}
function CircularProgressWithLabel(props) {
    const { value } = props
    return (
        <Box style={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress variant="determinate" {...props} style={{
                width: "25px",
                height: "24px",
                borderRadius: "100%",
                boxShadow: "inset 0 0 0px 2px #F5F8FA",
                backgroundColor: "transparent",
                color: value === 100 ? "#18cc69" : "#e99100"

            }} />
            <Box
                style={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography variant="caption" component="div" color="text.secondary">
                    {props.content}
                </Typography>
            </Box>
        </Box>
    );
}


// const SecondaryPermits = ({ record }) => {
//     const classes = useStyles();
//     const [open, setOpen] = React.useState(false)
//     const [secondaryUsers] = useState(JSON.parse(record.secondary_users))

//     const handleClose = () => {
//         setOpen(false)
//     }

//     const handleClickOpen = () => {
//         setOpen(true);
//     };

//     return (
//         <>
//             {secondaryUsers && secondaryUsers[0].id !== null && secondaryUsers[0].id !== 'null' &&
//                 <div>
//                     <IconButton style={{ color: "#18cc69" }} onClick={handleClickOpen}> <VisibilityIcon style={{ fontSize: "20px" }} /></IconButton>
//                     <Dialog
//                         open={open}
//                         onClose={handleClose}
//                         fullWidth
//                         classes={{ paper: classes.dialogPaperBig }}
//                     >
//                         <DialogContent>
//                             {secondaryUsers && secondaryUsers[0].id !== null && secondaryUsers[0].id !== 'null' ? <>
//                                 <Typography style={{ fontSize: 20, fontWeight: "bold" }}>Secondary Vehicles</Typography>
//                                 <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 270px)", gap: 10 }}>
//                                     {
//                                         secondaryUsers.map((user) => {

//                                             return (<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#F5F8FA", margin: "10px 0px", padding: "5px 20px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
//                                                     <div>{renderVehicleType(user)}</div>
//                                                     <div><p style={{ lineHeight: "0px", fontWeight: "600", fontSize: 15, color: "#1b232e" }}>{user.vehicle_number}</p>
//                                                         <p style={{ lineHeight: "2px", fontWeight: "400", fontSize: 14, color: "#BDBDBD" }}>{user.brand ? user.brand : "Unknown"} {user.model ? user.model : "Unknown"}</p></div>

//                                                 </div>
//                                                 {/* {user.tagID !== null && <div>{renderTagImageForPermit(user.tagID)}</div>} */}
//                                             </div>)
//                                         })
//                                     }
//                                 </div></>
//                                 : <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}><p style={{ lineHeight: "0px", fontWeight: "600" }}>Sorry! You don't have any Secondary User.</p></div>}
//                         </DialogContent>
//                         <DialogActions>
//                             <Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
//                                 Close
//                             </Button>
//                         </DialogActions>
//                     </Dialog>
//                 </div>}
//         </>
//     );
// }

function CreateToolbar(props) {
    const eventTracker = UseAnalyticsEvent()
    const { towerName, flatNumber, primaryUser, showSecondaryPermit, model, selectedBrand } = useContext(ContextProvider);
    //const notify = useNotify();
    const classes = useStyles();
    const history = useHistory();
    const { fastag } = props;

    const { input: { value: accessKeyId } } = useInput({ ...props, id: "access_key_id", source: "access_key_id" });
    const { input: { value: userType } } = useInput({ ...props, id: "user_type", source: "user_type" });
    const { input: { value: userSubType } } = useInput({ ...props, id: "user_sub_type", source: "user_sub_type" });
    const { input: { value: organizationId } } = useInput({ ...props, id: "organization_id", source: "organization_id" });
    //const { input: { value: towerName } } = useInput({ ...props, id: "tower_name", source: "tower_name" });
    //const { input: { value: flatNumber } } = useInput({ ...props, id: "flat_number", source: "flat_number" });
    const { input: { value: name } } = useInput({ ...props, id: "name", source: "name" });
    const { input: { value: gender } } = useInput({ ...props, id: "gender", source: "gender" });
    const { input: { value: mobileNumber } } = useInput({ ...props, id: "mobile", source: "mobile" });
    const { input: { value: vehicleNumber } } = useInput({ ...props, id: "vehicle_number", source: "vehicle_number" });
    const { input: { value: vehicleType } } = useInput({ ...props, id: "vehicle_type", source: "vehicle_type" });
    const { input: { value: rfid } } = useInput({ ...props, id: "rfid", source: "rfid" });

    const { input: { value: limitValidity } } = useInput({ ...props, id: "limit_validity", source: "limit_validity" });
    const { input: { value: registrationDate } } = useInput({ ...props, id: "registration_date", source: "registration_date" });
    const { input: { value: validTill } } = useInput({ ...props, id: "valid_till", source: "valid_till" });
    const { input: { value: amount } } = useInput({ ...props, id: "amount", source: "amount" });
    const { input: { value: paymentMethod } } = useInput({ ...props, id: "payment_method", source: "payment_method" });
    const { input: { value: chassisNumber } } = useInput({ ...props, id: "chassis_number", source: "chassis_number" });
    const { input: { value: additionalInfo } } = useInput({ ...props, id: "additional_info", source: "additional_info" });

    const [loading, setLoading] = useState(false);
    const [paymentFailedDialog, setPaymentFailedDialog] = useState(null);
    const [confirmationDialogVisible, setConfirmationDialogVisible] = useState(false);

    const updateRfidPaymentStatus = async (transactionId, paymentStatus, remarks) => {
        fetch(`${config.HOST_NAME}/crm/rfidData/${rfid}/payment/${transactionId}/status`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ payment_status: paymentStatus, remarks: remarks })
        });
    };

    const closePaymentFailedDialog = () => {
        setPaymentFailedDialog(null);
    };

    const openCashConfirmationDialog = () => {
        setConfirmationDialogVisible(true);
    };

    const closeConfirmationDialog = () => {
        setConfirmationDialogVisible(false);
    };

    const isDigitalPayment = () => {
        return limitValidity && paymentMethod !== "Cash" && paymentMethod !== "Self" && paymentMethod != null && paymentMethod !== "";
    };

    const onSubmit = (event) => {
        event.preventDefault();
        closeConfirmationDialog();

        if (props.invalid) {
            props.handleSubmit(event);
            return notify("Please fill all the details properly", "warning");
        }

        const params = {
            access_key_id: accessKeyId,
            user_type: userType,
            user_sub_type: userType && permitUserSubTypes[userType] ? userSubType : null,
            organization_id: userType === "company" ? organizationId : null,
            tower_name: userType === "resident" ? towerName : null,
            flat_number: userType === "resident" ? flatNumber : null,
            name: name,
            gender: gender,
            mobile: mobileNumber,
            vehicle_number: vehicleNumber.toUpperCase(),
            vehicle_type: vehicleType,
            brand: selectedBrand,
            model: model,
            rfid: rfid,
            registration_date: registrationDate ? registrationDate.valueOf() : null,
            limit_validity: limitValidity,
            valid_till: limitValidity ? validTill : null,
            amount: limitValidity ? amount : null,
            payment_method: limitValidity ? paymentMethod : null,
            is_fastag: vehicleType === "4" && fastag,
            chassis_number: chassisNumber,
            secondary_user: false,
            create_permit_without_mobile: sessionStorage.getItem("create_permit_without_mobile") === "1",
            additional_info: additionalInfo
        };

        let primaryUserParams = {
            access_key_id: accessKeyId,
            user_type: userType,
            user_sub_type: userType && permitUserSubTypes[userType] ? userSubType : null,
            organization_id: userType === "company" ? organizationId : null,
            name: name,
            gender: gender,
            mobile: mobileNumber,
            vehicle_number: vehicleNumber.toUpperCase(),
            vehicle_type: vehicleType,
            brand: selectedBrand,
            model: model,
            rfid: rfid,
            amount: primaryUser.amount,
            limit_validity: primaryUser.limit_validity,
            valid_till: primaryUser.valid_till,
            registration_date: registrationDate ? registrationDate.valueOf() : null,
            payment_method: primaryUser.payment_method,
            is_fastag: vehicleType === "4" && fastag,
            primary_permit_id: primaryUser.id,
            chassis_number: chassisNumber,
            secondary_user: true,
            create_permit_without_mobile: sessionStorage.getItem("create_permit_without_mobile") === "1",
            additional_info: additionalInfo
        }

        if (params.access_key_id == null || params.access_key_id === "") {
            return notify("Parking is Required", "warning");
        }
        if (params.user_type == null || params.user_type === "") {
            return notify("User Type is Required", "warning");
        }
        if(!params.user_type || !permitUserSubTypes[params.user_type] || !permitUserSubTypes[params.user_type].includes(params.user_sub_type)) {
            params.user_sub_type = null;
        }
        if (params.user_type === "company" && (params.organization_id == null || params.organization_id === "")) {
            return notify("Company is Required", "warning");
        }
        if (params.user_type === "resident") {
            if (params.tower_name == null || params.tower_name === "") {
                return notify("Tower Name is Required", "warning");
            }
            if (params.flat_number == null || params.flat_number === "") {
                return notify("Flat Number is Required", "warning");
            }
        }
        if (params.rfid == null || params.rfid === "") {
            return notify("RFID is Required", "warning");
        }
        let validTillDateMoment;
        if (params.limit_validity) {
            if (params.valid_till == null) {
                return notify("Valid Till Date is Required", "warning");
            }
            validTillDateMoment = moment(params.valid_till);
            if (!validTillDateMoment.isValid()) {
                return notify("Invalid Valid Till Date", "warning");
            }
            if (params.amount == null || params.amount === "") {
                params.amount = 0;
            } else if (isNaN(params.amount) || parseFloat(params.amount) < 0) {
                return notify("Invalid Amount", "warning");
            }
            if (params.payment_method == null || params.payment_method === "") {
                params.payment_method = "Cash";
            }
        }

        setLoading(true);
        if (isDigitalPayment()) {
            closePaymentFailedDialog();
            eventTracker("PERMIT SECTION", "INITIATE PERMIT PAYMENT")
            fetch(`${config.HOST_NAME}/crm/rfidData/initiateRfidPayment`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ rfid: rfid, amount: amount, access_key_id: params.access_key_id })
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    if (json.success) {
                        const order = json.data.order;
                        var options = {
                            description: 'Permit Charges',
                            currency: order.currency,
                            key: config.RAZOR_PAY_KEY_ID,
                            amount: order.amount,
                            name: 'ParkSmart',
                            order_id: order.id,
                            notes: {
                                rfid: rfid,
                                parking_name: json.data.parking_name,
                            },
                            prefill: {
                                name: params.name,
                                contact: params.mobile
                            },
                            theme: {
                                color: customTheme.palette.primary.main
                            },
                            modal: {
                                ondismiss: () => {
                                    setLoading(false);
                                    const description = "Payment is cancelled by user";
                                    setPaymentFailedDialog(description);
                                    updateRfidPaymentStatus(json.data.transaction_id, "CANCELLED", description);
                                }
                            },
                            handler: checkoutData => {
                                eventTracker("PERMIT SECTION", "VERIFY PERMIT PAYMENT");
                                fetch(`${config.HOST_NAME}/crm/rfidData/verifyRfidPayment`, {
                                    method: 'POST',
                                    headers: {
                                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                                        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({ ...checkoutData, transaction_id: json.data.transaction_id, ...params }),
                                })
                                    .then(response => {
                                        saveTokens(response)
                                        return response.json()
                                    })
                                    .then(json => {
                                        setLoading(false);
                                        if (json.success) {
                                            notify("Payment Successful", "success");
                                            eventTracker("PERMIT SECTION", "PERMIT ISSUED", "Permit Issued Digitally")
                                            history.push(props.basePath);
                                        } else {
                                            setPaymentFailedDialog(json.message);
                                        }
                                    })
                                    .catch((error) => {
                                        setLoading(false);
                                        setPaymentFailedDialog("Could not verify Payment");
                                    });
                            },
                        }
                        const razorpay = new window.Razorpay(options);
                        razorpay.on('payment.failed', function ({ error }) {
                            setLoading(false);
                            let description, status;
                            if (isJsonString(error.description)) {
                                const errorObj = JSON.parse(error.description);
                                if (errorObj.error) {
                                    description = errorObj.error.description;
                                    status = errorObj.error.reason;
                                } else {
                                    description = errorObj.description;
                                    status = errorObj.reason;
                                }
                            } else {
                                description = error.description;
                            }
                            setPaymentFailedDialog(description);
                            eventTracker("PERMIT SECTION", status === "payment_cancelled" ? "CANCELLED" : "FAILED", description)
                            updateRfidPaymentStatus(json.data.transaction_id, status === "payment_cancelled" ? "CANCELLED" : "FAILED", description);
                        });

                        razorpay.open();
                    } else {
                        setLoading(false);
                        notify(json.message, "warning");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    setLoading(false);
                    notify("Check your internet connection", "warning");
                });
        } else {
            eventTracker("PERMIT SECTION", "ISSUE PERMIT");
            fetch(`${config.HOST_NAME}/crm/rfidData/issueRfidPermit`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(primaryUser.id && showSecondaryPermit ? primaryUserParams : params),
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    setLoading(false);
                    if (json.success) {
                        notify("Permit Issued", "success");
                        eventTracker("PERMIT SECTION", "PERMIT ISSUED", "Permit Issued by CASH")
                        history.push(props.basePath);
                    } else {
                        notify(json.message, "warning");
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    notify("Server could not be connected", "warning");
                });
        }
    };

    return (
        <RaToolbar style={{ marginTop: 22 }}>
            <div style={{ display: "flex", width: "100%" }}>
                {!showSecondaryPermit && <Typography variant="h6" style={{ marginRight: 30, color: "#47c", flex: 1, visibility: limitValidity ? "visible" : "hidden" }}>₹{amount ? amount : 0}</Typography>}
                <Button
                    disableElevation
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    style={{ textTransform: "none", minWidth: 100, padding: "8px 4.5%", justifySelf: "flex-end" }}
                    onClick={isDigitalPayment() && !showSecondaryPermit ? onSubmit : openCashConfirmationDialog}
                >
                    {isDigitalPayment() && !showSecondaryPermit ? "Pay" : "Save"}
                </Button>
            </div>

            {loading && <Portal>
                <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100vh", backgroundColor: "#0001", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress size={50} />
                </div>
            </Portal>}

            <Portal>
                <Dialog open={!!paymentFailedDialog} onClose={closePaymentFailedDialog} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle style={{ color: customTheme.palette.error.main }}><div style={{ fontSize: 16, textAlign: "center" }}>Payment Failed!</div></DialogTitle>
                    <DialogContent style={{ fontSize: 14, marginTop: 0, marginBottom: 10 }}>Description: {paymentFailedDialog}</DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "space-evenly" }}>
                        <Button className={classes.dialogButton} variant="outlined" color="default" onClick={closePaymentFailedDialog}>Cancel</Button>
                        <Button disableElevation className={classes.dialogButton} variant="contained" color="secondary" onClick={onSubmit}>Retry</Button>
                    </DialogActions>
                </Dialog>
            </Portal>

            <Portal>
                <Dialog open={confirmationDialogVisible} onClose={closeConfirmationDialog} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle style={{ color: customTheme.palette.secondary.main }}><div style={{ fontSize: 16, textAlign: "center" }}>Confirmation</div></DialogTitle>
                    <DialogContent style={{ fontSize: 14, marginTop: 0, marginBottom: 10 }}>Are you sure you want to issue this permit?</DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "space-evenly" }}>
                        <Button className={classes.dialogButton} variant="outlined" color="default" onClick={closeConfirmationDialog}>Cancel</Button>
                        <Button disableElevation className={classes.dialogButton} style={{ padding: "8px 40px" }} variant="contained" color="secondary" onClick={onSubmit}>Yes</Button>
                    </DialogActions>
                </Dialog>
            </Portal>
        </RaToolbar>
    );
};
const vehicleTypes = {
    "2": { name: "Scooter" },
    "4": { name: "Car" },
}
function ValidityAmountInputForRequest(props) {
    //const notify = useNotify();

    const {
        accessKeyId, vehicle_type, amountText, setAmountText, months, setMonths, gstToggle,
        setGstToggle, gstAmount, setGstAmount, totalAmount, setTotalAmount, paymentMethod, setPaymentMethod,
    } = props

    const paymentMethodHandler = (event) => {
        setPaymentMethod(event.target.value);
    }

    const handleAmountChange = (event) => {
        if (!isNaN(event.target.value)) {
            setAmountText(event.target.value);
            if(+event.target.value === 0){
                setPaymentMethod("Cash")
            }
        }
    }

    const incrementMonth = () => {
        setMonths(months + 1);
    }

    const decrementMonth = () => {
        if (months > 1) setMonths(months - 1);
    }

    const gstHandler = () => {
        setGstToggle(!gstToggle);

    }
    if (gstToggle) {
        setGstAmount((9 / 100) * Number(amountText) + (9 / 100) * Number(amountText));
    }
    if (gstToggle && amountText) {
        setTotalAmount((Number(amountText) + Number(gstAmount)));
    } else {
        setTotalAmount(amountText);
    }

    useEffect(() => {
        if (accessKeyId) {
            fetch(`${config.HOST_NAME}/crm/v3/parkings?user_id=${sessionStorage.getItem("user_id")}&filter=${JSON.stringify({ id: [accessKeyId], includeSocieties: true })}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                }
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    if (json.success && json.data[0] && json.data[0].features && json.data[0].features.permit) {
                        //console.log(json.data[0].features.permit)
                        if (vehicle_type === "4") {
                            setAmountText(json.data[0].features.permit.amount.Car)
                        }
                        if (vehicle_type === "2") {
                            setAmountText(json.data[0].features.permit.amount.Scooter)
                        }
                    } else {
                        notify(json.message, "warning");
                    }
                })
                .catch(error => {
                    notify("Something went wrong", "warning");
                    console.log(error);
                });
        }
    }, [accessKeyId]); // eslint-disable-line react-hooks/exhaustive-deps



    return (
        <div style={{ width: '100%', marginBottom: 15 }}>
            <div
                className="grid-250"
                style={{ marginTop: 8, alignItems: 'flex-end' }}
            >
                <div>
                    <div className="formLabel-regular" style={{ marginBottom: 3 }}>
                        Amount*
                    </div>
                    <MuiTextField
                        value={amountText}
                        onChange={handleAmountChange}
                        label=""
                        variant="outlined"
                        size="small"
                    />
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        columnGap: 10,
                        marginTop: 8,
                    }}
                >
                    <Button
                        onClick={decrementMonth}
                        style={{
                            backgroundColor: '#aaa',
                            color: '#fff',
                            minWidth: 35,
                            width: '20%',
                            height: 38,
                            opacity: 0.6,
                        }}
                        disabled={months <= 1}
                    >
                        <RemoveIcon style={{ fontSize: 23 }} />
                    </Button>
                    <div
                        style={{
                            border: '1px solid #bbb',
                            color: '#666',
                            padding: '7px 12%',
                            borderRadius: 5,
                        }}
                    >
                        {months === 1 ? '1 Month' : `${months} Months`}
                    </div>
                    <Button
                        onClick={incrementMonth}
                        style={{
                            backgroundColor: '#aaa',
                            color: '#fff',
                            minWidth: 35,
                            width: '20%',
                            height: 38,
                            opacity: 0.6,
                        }}
                        disabled
                    >
                        <AddIcon style={{ fontSize: 21 }} />
                    </Button>
                </div>
            </div>
            <FormControlLabel
                className="formLabel-regular"
                checked={gstToggle}
                onChange={gstHandler}
                control={<Checkbox color="primary" />}
                label="Add GST"
                style={{ marginTop: 5 }}
            />
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: '80% 20%',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    maxWidth: 500,
                }}
            >
                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                    Amount
                </Typography>
                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                    ₹
                    {gstToggle && amountText !== "" ? amountText : amountText ? (amountText - (9 / 100) * amountText * 2) : amountText === "" ? 0 : 0}
                </Typography>
                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                    CGST 9%
                </Typography>
                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                    ₹{((9 / 100) * amountText)}
                </Typography>
                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                    SGST 9%
                </Typography>
                <Typography style={{ fontFamily: 'Poppins-Regular', fontSize: 15 }}>
                    ₹{((9 / 100) * amountText)}
                </Typography>
                <Typography style={{ fontSize: 15 }}>Total</Typography>
                <Typography style={{ fontSize: 15 }}>
                    ₹{' '}
                    {amountText && gstToggle ? totalAmount : amountText ? amountText : 0}
                </Typography>
            </div>

            {+amountText !== 0 &&
                <>
                    <div className="formLabel-bold" style={{ marginTop: 25 }}>
                        Payment Method
                    </div>
                    <RadioGroup
                        row
                        value={paymentMethod}
                        onChange={paymentMethodHandler}
                        style={{ columnGap: 15 }}
                    >
                        <FormControlLabel
                            className="formLabel-regular"
                            value="Self"
                            control={<Radio color="primary" />}
                            label="App"
                        />
                        <FormControlLabel
                            className="formLabel-regular"
                            value="Cash"
                            control={<Radio color="primary" />}
                            label="Cash"
                        />
                        <FormControlLabel
                            className="formLabel-regular"
                            value="Digital"
                            control={<Radio color="primary" />}
                            label="Digital"
                        />
                    </RadioGroup>
                </>
            }
        </div>
    )
}
function ValidityAmountInput(props) {
    //const notify = useNotify();

    const { input: { value: accessKeyId } } = useInput({ ...props, id: "access_key_id", source: "access_key_id" });
    const { input: { value: vehicleType } } = useInput({ ...props, id: "vehicle_type", source: "vehicle_type" });
    const { input: { value: limitValidity } } = useInput({ ...props, id: "limit_validity", source: "limit_validity" });
    const { input: { value: registrationDate } } = useInput({ ...props, id: "registration_date", source: "registration_date" });
    const { input: { onChange: setValidTill } } = useInput({ ...props, id: "valid_till", source: "valid_till" });
    const { input: { value: amount, onChange: setAmount } } = useInput({ ...props, id: "amount", source: "amount" });
    const { input: { value: paymentMethod, onChange: setPaymentMethod } } = useInput({ ...props, id: "payment_method", source: "payment_method" });

    const [months, setMonths] = useState(1);
    const [parkingPermitConfig, setParkingPermitConfig] = useState({ amount: {}, gst_enabled: false, gst_percentage: 18 });
    const [amountText, setAmountText] = useState("0");
    const [baseAmount, setBaseAmount] = useState(0);
    const [gstAmount, setGstAmount] = useState(0);


    const handleAmountChange = event => {
        if (!isNaN(event.target.value)) {
            setAmountText(event.target.value);
            if(+event.target.value === 0){
                setPaymentMethod("Cash")
            }
            if (event.target.value === "") {
                setParkingPermitConfig({ ...parkingPermitConfig, amount: { ...parkingPermitConfig.amount, [vehicleTypes[vehicleType].name]: 0 } });
            } else {
                setParkingPermitConfig({ ...parkingPermitConfig, amount: { ...parkingPermitConfig.amount, [vehicleTypes[vehicleType].name]: parseInt(event.target.value) } });
            }
        }
    };

    const handleAmountBlur = event => {
        if (event.target.value === "") {
            setAmountText("0");
        }
    };

    const incrementMonth = () => {
        setMonths(months + 1);
    };

    const decrementMonth = () => {
        if (months > 1)
            setMonths(months - 1);
    };

    const toggleGst = (event) => {
        setParkingPermitConfig({ ...parkingPermitConfig, gst_enabled: event.target.checked });
    };

    useEffect(() => {
        setPaymentMethod("Self");
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (accessKeyId) {
            fetch(`${config.HOST_NAME}/crm/v3/parkings?user_id=${sessionStorage.getItem("user_id")}&filter=${JSON.stringify({ id: [accessKeyId], includeSocieties: true })}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                }
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    if (json.success && json.data[0] && json.data[0].features && json.data[0].features.permit) {
                        setParkingPermitConfig(json.data[0].features.permit);
                    } else {
                        notify(json.message, "warning");
                    }
                })
                .catch(error => {
                    notify("Something went wrong", "warning");
                    console.log(error);
                });
        }
    }, [accessKeyId]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!limitValidity || !registrationDate) {
            setValidTill(null);
        } else {
            if(paymentMethod === "Self") {
                setValidTill(moment().utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss"));
            }else {
                setValidTill(moment(registrationDate).utcOffset("+05:30").add(months, "month").subtract(1, "day").format("YYYY-MM-DD 23:59:59"));
            }
        }

    }, [months, limitValidity, registrationDate, paymentMethod]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (limitValidity && vehicleType && parkingPermitConfig.amount[vehicleTypes[vehicleType].name] >= 0) {
            const amountNumber = parkingPermitConfig.amount[vehicleTypes[vehicleType].name];
            setAmountText(`${amountNumber}`);
            let bAmount, gAmount, finalAmount = amountNumber * months;
            if (parkingPermitConfig.gst_enabled) {
                bAmount = finalAmount;
                gAmount = bAmount * parkingPermitConfig.gst_percentage / 100;
                finalAmount = bAmount + gAmount;
            } else {
                bAmount = finalAmount / (1 + parkingPermitConfig.gst_percentage / 100);
                gAmount = bAmount * parkingPermitConfig.gst_percentage / 100;
            }
            setAmount(finalAmount);
            setBaseAmount(bAmount);
            setGstAmount(gAmount);
        } else {
            setAmount(0);
        }
    }, [limitValidity, months, parkingPermitConfig, vehicleType]); // eslint-disable-line react-hooks/exhaustive-deps   

    if (!limitValidity)
        return null;

    return (<div style={{ width: "100%", marginBottom: 15 }}>
        <div className="grid-250" style={{ marginTop: 8, alignItems: "flex-end" }}>
            <div>
                <div className="formLabel-regular" style={{ marginBottom: 3 }}>Amount*</div>
                <MuiTextField value={amountText} onChange={handleAmountChange} onBlur={handleAmountBlur} label="" variant="outlined" size="small" disabled={!vehicleType} />
            </div>
            <div style={{ display: "flex", alignItems: "center", columnGap: 10 }}>
                <Button onClick={decrementMonth} style={{ backgroundColor: "#aaa", color: "#fff", minWidth: 35, width: "20%", height: 38, opacity: 0.6 }} disabled={months <= 1}><RemoveIcon style={{ fontSize: 23 }} /></Button>
                <div style={{ border: "1px solid #bbb", color: "#666", padding: "7px 12%", borderRadius: 5 }}>{months === 1 ? "1 Month" : `${months} Months`}</div>
                <Button onClick={incrementMonth} style={{ backgroundColor: "#aaa", color: "#fff", minWidth: 35, width: "20%", height: 38, opacity: 0.6 }} disabled><AddIcon style={{ fontSize: 21 }} /></Button>
            </div>
        </div>
        <FormControlLabel className="formLabel-regular" checked={parkingPermitConfig.gst_enabled} control={<Checkbox color="primary" />} label="Add GST" onChange={toggleGst} style={{ marginTop: 5 }} />
        <div style={{ display: "grid", gridTemplateColumns: "80% 20%", justifyContent: "space-around", alignItems: "center", maxWidth: 500 }}>
            <Typography style={{ fontFamily: "Poppins-Regular", fontSize: 15 }}>Amount</Typography><Typography style={{ fontFamily: "Poppins-Regular", fontSize: 15 }}>₹{baseAmount}</Typography>
            <Typography style={{ fontFamily: "Poppins-Regular", fontSize: 15 }}>CGST ({parkingPermitConfig.gst_percentage / 2}%)</Typography><Typography style={{ fontFamily: "Poppins-Regular", fontSize: 15 }}>₹{(gstAmount / 2)}</Typography>
            <Typography style={{ fontFamily: "Poppins-Regular", fontSize: 15 }}>SGST ({parkingPermitConfig.gst_percentage / 2}%)</Typography><Typography style={{ fontFamily: "Poppins-Regular", fontSize: 15 }}>₹{(gstAmount / 2)}</Typography>
            <Typography style={{ fontSize: 15 }}>Total</Typography><Typography style={{ fontSize: 15 }}>₹{amount ? amount : 0}</Typography>
        </div>

        {+amountText !== 0 &&
            <>
                <div className="formLabel-bold" style={{ marginTop: 25 }}>Payment Method</div>
                <RadioGroup row value={paymentMethod} onChange={event => setPaymentMethod(event.target.value)} style={{ columnGap: 15 }}>
                    <FormControlLabel className="formLabel-regular" value="Self" control={<Radio color="primary" />} label="App" />
                    <FormControlLabel className="formLabel-regular" value="Cash" control={<Radio color="primary" />} label="Cash" />
                    <FormControlLabel className="formLabel-regular" value="Digital" control={<Radio color="primary" />} label="Digital" />
                </RadioGroup>
            </>
        }
    </div>);
};
function FastagSelector(props) {
    //const notify = useNotify();
    const { isAnprOnly } = props;
    const { input: { value: rfid, onChange: setRfid } } = useInput({ ...props, id: "rfid", source: "rfid" });
    const { input: { value: vehicleNumber } } = useInput({ ...props, id: "vehicle_number", source: "vehicle_number" });
    const { input: { value: chassisNumber } } = useInput({ ...props, id: "chassis_number", source: "chassis_number" });
    const [fastagData, setFastagData] = useState([]);
    const [fastagLoading, setFastagLoading] = useState(false);
    const [isFasTag, setisFasTag] = useState(false)
    const [value, setValue] = React.useState();
    const [testValue, setTestValue] = useState("")

    const handleChange = (event) => {
        setValue(event.target.value);
        setTestValue(event.target.value)
        onRfidInputChange(event)
    };

    const getFastags = () => {
        const vehicleNumberValidation = validateVehicleNumber(vehicleNumber);
        if (vehicleNumberValidation !== true) {
            notify(vehicleNumberValidation, "warning");
            return;
        }
        setFastagLoading(true);
        fetch(`${config.HOST_NAME}/crm/fastags?vehicle_number=${vehicleNumber}&chassis_number=${chassisNumber}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setFastagLoading(false);
                if (json.success) {
                    const getFastagIssuerIdArray = (tagsArray) => {
                        let onlyTagsArray = tagsArray.map((val) => {
                            let tagIdBin = "";
                            for (let i = 0; i < val.TAGID.length; i++) {
                                tagIdBin += (parseInt(val.TAGID[i], 16).toString(2)).padStart(4, "0");
                            }
                            const issuerId = parseInt(tagIdBin.substr(43, 20), 2).toString();
                            const tagName = fastagIssuers[issuerId] ? fastagIssuers[issuerId] : "Unknown"
                            return { ...val, tagName: tagName }
                        })
                        return onlyTagsArray
                    };
                    const issuerIdArray = getFastagIssuerIdArray(json.data);
                    setFastagData(issuerIdArray);
                    setValue(issuerIdArray[0].TAGID)
                    setRfid(issuerIdArray[0].TAGID)
                    setTestValue(issuerIdArray[0].TAGID)

                } else {
                    notify(json.message, "warning");
                }
            })
            .catch(error => {
                setFastagLoading(false);
                notify("Something went wrong", "warning");
                console.log(error);
            });
    };

    function fastagHandler(epcString) {
        if (epcString.search(/^34/g) !== -1) {
            return parseInt(parseInt(epcString, 16).toString(2).padStart(epcString.length * 4, "0").substring(14, 38), 2) === 8907272
        } else {
            return epcString.search(/^918907048/g) !== -1
        }
    };

    const onRfidInputChange = event => {
        setRfid(event.target.value);
        setisFasTag(fastagHandler(event.target.value))
    };

    const fasTagStatusRender = (tag) => {

        if (tag) {
            if (tag.length > 6) {
                let tagsArr = tag.split(",")

                return tagsArr[0]
            }
            return tag
        }
        return ""
    }

    useEffect(() => {
        setisFasTag(fastagHandler(rfid))
        return () => {
            setRfid("");
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(isAnprOnly) {
            setRfid(`gen-${vehicleNumber}-${Date.now()}`);
        }
    }, [vehicleNumber, isAnprOnly]); // eslint-disable-line react-hooks/exhaustive-deps

    if(isAnprOnly)
        return null;
        
    return <div style={{ marginBottom: 15, width: "100%", minHeight: 81 }}>
        {/* <div style={{ marginBottom: 20, display: "flex", alignItems: "center", columnGap: 25 }}>
            <Button variant="contained" color="secondary" onClick={getFastags} disableElevation style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", padding: "8px 4%", minWidth: 120 }}>{fastagData ? "Refresh" : "Fetch Fastag"}</Button>
            {fastagLoading && <CircularProgress color="secondary" size={25} />}
        </div> */}
        {fastagData.length !== 0 ?
            <FormControl>
                <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={testValue}
                    onChange={handleChange}
                    defaultValue={fastagData[0].TAGID}
                    row
                >

                    {
                        fastagData.map((tags) => {
                            return (
                                <div onClick={() => handleChange({ target: { value: tags.TAGID } })} style={{ position: "relative", width: 300, border: tags["TAGID"] === value ? "2px solid #18cc69" : "2px solid #D1DBE8", borderRadius: 12, margin: "0px 20px 20px 0px", cursor: "pointer" }}>
                                    <div style={{ backgroundImage: `url(${FasTagCard})`, color: "#fff", borderRadius: 10, left: 0, display: "flex", flexDirection: "column", height: "175px", backgroundRepeat: "no-repeat", backgroundSize: "100%" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", flex: 1, padding: "22px 18px" }}>
                                            <div style={{ display: "flex", justifyContent: "end", color: "#18cc69" }}>
                                                <FormControlLabel color='primary' className="formControlLabel-small" value={tags["TAGID"]} control={<Radio color="primary" size="small" />} label={
                                                    <Box component="div" fontSize={14}>
                                                        {tags["TAGID"] === value ? "Selected" : "Select"}
                                                    </Box>
                                                } style={{ color: tags["TAGID"] === value ? "#18cc69" : "#9d9d9d", position: "relative", top: -9, right: -26 }} />
                                            </div>
                                            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", position: "absolute", top: 70, left: 3, width: "100%" }}>
                                                <div style={{ position: "relative", left: 15 }}>{renderTagImagee(tags["TAGID"])}</div>
                                                <div style={{ color: "#fff", fontSize: 12, position: "relative", top: 6, right: 15 }}>{fasTagStatusRender(tags.tag_status)}</div>
                                            </div>


                                            {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                <div style={{ fontFamily: "Poppins-Regular", fontSize: 17, letterSpacing: "0.02em", color: "#fff" }}>
                                                    {tags["REGNUMBER"].replace(/\d*$/, "")}
                                                    <span style={{ color: "#18cc69", fontFamily: "Poppins-Medium" }}>{tags["REGNUMBER"].match(/\d*$/)}</span>
                                                </div>
                                                <img src={fastagImage} style={{ width: 95, height: 21 }} alt="FASTag Logo" />
                                            </div> */}
                                            {/* <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between" }}>
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                                                    <div style={{ backgroundColor: tags["TAGSTATUS"] === "A" && tags["EXCCODE"] === "00" ? customTheme.palette.primary.main : customTheme.palette.error.main, width: 14, height: 14, borderRadius: 100, marginRight: 7 }} />
                                                    <Typography style={{ fontSize: 13 }}>{tags["TAGSTATUS"] === "A" && tags["EXCCODE"] === "00" ? "Active" : "Inactive"}</Typography>
                                                </div>
                                                <div style={{ textAlign: "right" }}>
                                                    <div style={{ fontFamily: "Poppins-Regular", fontSize: 10, color: "#fff" }}>PAYMENT BANK</div>
                                                    <div style={{ fontFamily: "Poppins-Medium", fontSize: 15, color: "#fff", textTransform: "uppercase" }}>{tags["ISSUER"]}</div>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>

                                </div>
                            )
                        })
                    }

                </RadioGroup>
            </FormControl>

            :
            <>
                <div className="formLabel-regular" style={{ margin: "10px 0 0px", position: "relative", top: 4 }}>FASTag EPC ID Manually* <span>{isFasTag ?
                    <CheckIcon style={{ color: customTheme.palette.primary.main }} />
                    :
                    <span style={{ color: "#de575e", fontSize: 14, marginLeft: 5 }}>{rfid.length !== 0 ? "Invalid*" : ""}</span>
                }</span></div>
                <div>
                    <div style={{ display: "flex", width: "100%" }}>
                        <TextInput style={{ marginRight: 10, width: "100%" }} source="rfid" label="" variant="outlined" value={rfid} onChange={onRfidInputChange} />
                        <Button variant="contained" color="secondary" onClick={getFastags} disableElevation style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", width: "100%", height: "38px", marginTop: "8px" }}>Fetch FASTag {fastagLoading && <CircularProgress color="secondary" size={25} style={{ marginLeft: "10px" }} />}</Button>
                    </div>
                    <div className="formLabel-regular" style={{ margin: "0px 0 0px", position: "relative", bottom: 20, fontSize: 12 }} ><span style={{ color: "#707683", margin: 0 }}>To know your FASTag ID?</span><MuiLink style={{ textDecoration: 'none' }} href={`https://www.npci.org.in/what-we-do/netc-fastag/check-your-netc-fastag-status`} target="_blank"> Click here!</MuiLink></div>
                </div>
                {
                    rfid !== "" && renderTagImagee(rfid) &&
                    <div style={{ position: "relative", width: 300, border: "2px solid #18cc69", borderRadius: 12, marginRight: "20px" }}>
                        <div style={{ backgroundImage: `url(${FasTagCard})`, color: "#fff", borderRadius: 10, left: 0, display: "flex", flexDirection: "column", height: "175px", backgroundRepeat: "no-repeat", backgroundSize: "100%" }}>
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", flex: 1, padding: "22px 18px" }}>
                            </div>
                        </div>
                        <div style={{ position: "absolute", top: 69, left: 18, display: "flex", justifyContent: "center", alignItems: "center" }}>{rfid !== "" && renderTagImagee(rfid)}</div>

                    </div>
                }

            </>
        }
    </div>;
}
// const permitUserTypes = {
//     "Society": [
//         { id: 'resident', name: 'Resident' }
//     ],
//     "Commercial": [
//         { id: 'company', name: 'Company' },
//         { id: 'staff', name: 'Staff' },
//         { id: 'individual', name: 'Individual' }
//     ]
// };

const permitUserSubTypes = {
    "resident": [
        { id: 'Owner', name: 'Owner' },
        { id: 'Tenant', name: 'Tenant' }
    ],
}
const permitVehicleTypes = [
    { id: '2', name: '2-Wheeler' },
    { id: '4', name: '4-Wheeler' },
    { id: '6', name: '6-Wheeler' },
];
const validateVehicleNumber = vehicleNumber => {
    if (vehicleNumber == null || vehicleNumber === "") {
        return "Vehicle Number is Required";
    } else if (vehicleNumber.length > 200) {
        return "Vehicle Number is too long";
    } else if (new RegExp("^[0-9]*$").test(vehicleNumber)) {
        return "Invalid Vehicle Number";
    }
    else if (new RegExp("^[a-zA-Z]*$").test(vehicleNumber)) {
        return "Invalid Vehicle Number";
    }
    else if (!new RegExp("^[A-Za-z0-9]*$").test(vehicleNumber)) {
        return "Invalid Vehicle Number";
    }
    return true;
};
const validateUserCreation = (values, createPermitNameRequired, createPermitWithoutMobile) => {

    const errors = {};

    if (!createPermitWithoutMobile) {
        if (values.mobile == null || values.mobile === "") {
            errors.mobile = 'Mobile Number is Required';
        } else if (values.mobile.search(/^\d{10}$/g) === -1) {
            errors.mobile = 'Invalid Mobile Number';
        }
    }

    if ((values.mobile == null || values.mobile === "") && (values.additional_info == null || values.additional_info === "")) {
        errors.additional_info = 'Additional Info is required';
    }


    if (createPermitNameRequired) {
        if (values.name == null || values.name === "") {
            errors.name = "Name is Required"
        }
    }

    const vehicleNumberValidation = validateVehicleNumber(values.vehicle_number);
    if (vehicleNumberValidation !== true) {
        errors.vehicle_number = vehicleNumberValidation;
    }
    if (values.vehicle_type == null || values.vehicle_type === "") {
        errors.vehicle_type = 'Vehicle Type is Required';
    }

    if (values.registration_date == null || values.registration_date === "") {
        errors.registration_date = 'Please specify the Registration Date';
    }

    return errors;
};
export const NewRfidDataCreate = ({ permissions, ...props }) => {
    //const notify = useNotify()
    const history = useHistory()
    const { setTowerName, setFlatNumber, flatNumber, setPrimaryUser, primaryUser, showSecondaryPermit, setShowSecondaryPermit, model, setModel, selectedBrand, setSelectedBrand } = useContext(ContextProvider);
    const [allowUnallocatedRfid] = useState(sessionStorage.getItem("allow_unallocated_rfid") === "1");
    const [allowFastag] = useState(sessionStorage.getItem("allow_fastag") === "1");
    const [userTypes, setUserTypes] = useState([]);
    const [userType, setUserType] = useState(undefined);
    const [userSubType, setUserSubType] = useState(undefined);
    const [vehicleNumber, setVehicleNumber] = useState("");
    const [vehicleNumberOnBLur, setVehicleNumberOnBlur] = useState(false);
    const [vehicleType, setVehicleType] = useState(null);
    const [useFastag, setUseFastag] = useState(false);
    const [limitValidity, setLimitValidity] = useState(sessionStorage.getItem("rfid_validity_default") === "1" ? true : false);
    const [showSubTypes, setShowSubTypes] = useState(false);
    const [isAnprOnly, setIsAnprOnly] = useState(false);
    const [allowStartDate] = useState(sessionStorage.getItem("company_user") === "1" && sessionStorage.getItem("rfid_validity_default") === "1" ? false : true);
    const [validityToggleVisible, setValidityToggleVisible] = useState(false);
    const [chassisNumber, setChassisNumber] = useState("")
    const [createPermitNameRequired] = useState(sessionStorage.getItem("create_permit_name_required") === "1");
    const [createPermitWithoutMobile] = useState(sessionStorage.getItem("create_permit_without_mobile") === "1");

    const [towersNames, setTowersNames] = useState([])
    const [towerFlatDetails, setTowerFlatDetails] = useState({})
    const [flatNumbers, setFlatNumbers] = useState([])
    const [flatField, setFlatField] = useState(false)

    const [value, setValue] = React.useState("");
    const [inputValue, setInputValue] = React.useState('');
    const [value2, setValue2] = React.useState("");
    const [inputValue2, setInputValue2] = React.useState('');

    const [accessKeyId, setAccessKeyId] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [primaryUsers, setPrimaryUsers] = useState([]);

    const [bikeBrands, setBikeBrands] = useState([]);
    const [carBrands, setCarBrands] = useState([]);
    const [busBrands, setBusBrands] = useState([]);

    const [isNotifyMessageClicked, setIsNotifyMessageClicked] = useState(false)

    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Created", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }

    const onUseFastagToggle = event => {
        setUseFastag(event.target.checked);
    };

    const onLimitValidityToggle = checked => {
        setLimitValidity(checked);
    };

    const onParkingSelect = async (accessKeyId) => {
        setAccessKeyId(accessKeyId)
        fetch(`${config.HOST_NAME}/crm/parkingAccessKeys/${accessKeyId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then((json) => {
                if (json.success) {
                    const permitUserTypes = {
                        "Society": [
                            { id: 'resident', name: 'Resident' },
                            { id: 'staff', name: `Staff` },
                        ],
                        "Commercial": [
                            { id: 'company', name: 'Company' },
                            { id: 'staff', name: `${json.data.name} Staff` },
                            { id: 'individual', name: 'Individual' }
                        ],
                        "School": [
                            { id: 'company', name: 'Company' },
                            { id: 'staff', name: `${json.data.name} Staff` },
                            { id: 'Management', name: 'Management' }
                        ]
                    };

                    setShowSubTypes(json.data.allow_permit_sub_types);
                    setIsAnprOnly(json.data.is_anpr_only);
                    if (json.data.parking_type === "Society") {

                        let towersNames = json.data.allTowerFlatDetails.map((tower) => {
                            return tower.tower_name
                        })
                        let data = json.data.allTowerFlatDetails
                        let result = Object.fromEntries(data.map(({ tower_name, flats }) =>
                            [tower_name, JSON.parse(flats)]
                        ));
                        setTowersNames(towersNames)
                        setTowerFlatDetails(result)
                        setLimitValidity(false);
                        setValidityToggleVisible(false);
                    } else if (sessionStorage.getItem("company_user") === "1" && sessionStorage.getItem("rfid_validity_default") === "1") {
                        setValidityToggleVisible(false);
                    } else {
                        setValidityToggleVisible(true);
                    }

                    if (json?.data?.parking_type === "Commercial") {
                        setUserTypes(accessKeyId && accessKeyId === 1381 ? [{ id: 'company', name: 'Company' }] : permitUserTypes["Commercial"])
                        setUserType(permitUserTypes["Commercial"][0].id);
                    }
                    if (json?.data?.parking_type === "Society") {
                        setUserTypes(permitUserTypes["Society"])
                        setUserType(permitUserTypes["Society"][0].id);
                    }
                    if (json?.data?.parking_type === "School") {
                        setUserTypes(permitUserTypes["School"])
                        setUserType(permitUserTypes["School"][0].id);
                    }
                }
            })
            .catch((e) => { });
    };

    const getCommonData = () => {

        fetch(
            `${config.HOST_NAME}/crm/commonData`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        )
            .then(response => response.json())
            .then(json => {
                setBikeBrands({ ...json.bikeBrands, Other: ["Other"] });
                setCarBrands({ ...json.carBrands, Other: ["Other"] });
                setBusBrands({ ...json.busBrands, Other: ["—", "Other", "Unknown"] });
            })
            .catch(error => {
                console.log(error);
                notify("Check your internet connection.", "warning")

            });
    };

    const primaryUserHandler = (e) => {
        setPrimaryUser(e.target.value)
    }

    const getPrimaryUsers = () => {
        fetch(`${config.HOST_NAME}/crm/v3/primaryUsers?mobile=${mobileNumber}&access_key_id=${accessKeyId}&vehicle_type=${vehicleType}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    setPrimaryUsers(json.data)
                }
            })
            .catch(e => {
                console.log(e)
            });
    };

    const ExistingRequestMessage = ({ vehicle }) => {
        return <div onClick={() => setIsNotifyMessageClicked(true)}>
            <p style={{ color: "#272727", lineHeight: "16px" }}>
                A Permit Request of this vehicle already exists.
            </p>
            <p style={{ color: "#27272750", lineHeight: "3px" }}>
                Click here to accept it's request!
            </p>
        </div>
    }

    const notifyExistingRequest = (success) => {
        toast(success, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
        });
    }

    const getExistingPermitRequest = () => {
        fetch(`${config.HOST_NAME}/crm/v3/getExistingPermitRequest?mobile_number=${mobileNumber}&access_key_id=${accessKeyId}&vehicle_number=${vehicleNumber}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.success) {
                    notifyExistingRequest(<ExistingRequestMessage vehicle={json.data.vehicle_number} />)
                }
            })
            .catch(e => {
                console.log(e)
            });
    }
    React.useEffect(() => {
        if (accessKeyId && mobileNumber.length === 10 && accessKeyId !== "" && mobileNumber !== "" && userType !== "resident" && vehicleType) {
            getPrimaryUsers()
        } else {
            setPrimaryUsers([])
            setShowSecondaryPermit(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accessKeyId, mobileNumber, vehicleType])

    React.useEffect(() => {
        if (accessKeyId && mobileNumber.length === 10 && accessKeyId !== "" && mobileNumber !== "" && vehicleNumber && vehicleNumberOnBLur) {
            getExistingPermitRequest()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accessKeyId, mobileNumber, vehicleNumber, vehicleNumberOnBLur])

    useEffect(() => {
        getCommonData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (isNotifyMessageClicked) {
            history.push(`/rfidRequests?vehicle_number=${vehicleNumber}`)
            setIsNotifyMessageClicked(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isNotifyMessageClicked])

    return (<>
        <Helmet>
            <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
        </Helmet>

        <Create {...props} title="Create RFID Data" onFailure={onFailure} onSuccess={onSuccess}>
            <SimpleForm toolbar={<CreateToolbar fastag={useFastag} />} validate={(values) => validateUserCreation(values, createPermitNameRequired, createPermitWithoutMobile)} redirect="list">

                <div className="formLabel-bold" style={{ marginTop: 0 }}>Personal Details</div>
                <div className="grid-250">
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 10 }}>Location*</div>
                        <RaAutocompleteInput source="access_key_id" resourceParam="name" resourcePath="uniqueParkingAccessKeys" label="" getOptionValue={option => option["id"]} getOptionLabel={option => option["name"]} style={{ marginTop: 15, marginBottom: 25 }} onSelect={onParkingSelect} />
                    </div>
                </div>
                <div className="grid-250">
                    <div>
                        <div className="formLabel-regular">User Type*</div>
                        <SelectInput variant="outlined" label="" source="user_type" choices={userTypes} optionText="name" optionValue="id" defaultValue={userType} value={userType} onChange={event => setUserType(event.target.value)} style={{ display: "flex", position: "relative", top: -3 }} />
                    </div>
                    {showSubTypes && userType && permitUserSubTypes[userType] ? <div>
                        <div className="formLabel-regular">User Sub Type*</div>
                        <SelectInput variant="outlined" label="" source="user_sub_type" choices={permitUserSubTypes[userType]} optionText="name" optionValue="id" defaultValue={userSubType} value={userSubType} onChange={event => setUserSubType(event.target.value)} style={{ display: "flex", position: "relative", top: -3 }} />
                    </div> : null}
                    {userType === "company" && <div>
                        <div className="formLabel-regular">Company Name*</div>
                        <RaAutocompleteInput source="organization_id" resourceParam="name" resourcePath="rfidOrganization" label="" getOptionValue={option => option["id"]} getOptionLabel={option => option["name"]} useAccessKeyId={true} style={{ minWidth: 280, maxWidth: 500, position: "relative", top: 3, marginBottom: 35 }} />
                    </div>}
                    {userType === "resident" && <>
                        <div>
                            <div className="formLabel-regular" style={{ marginBottom: "30px" }}>Tower*</div>
                            <Autocomplete
                                value={value}
                                onOpen={() => {
                                    setValue2("")
                                    setInputValue2("");
                                    setFlatNumber("")
                                }}
                                onChange={(event, newValue) => {
                                    setValue(newValue);
                                    setTowerName(newValue)
                                    setFlatNumbers(() => {
                                        if (towerFlatDetails[newValue] !== undefined) {
                                            setFlatField(false)
                                            return towerFlatDetails[newValue]
                                        }
                                        setFlatField(true)
                                    });
                                }}
                                inputValue={inputValue}
                                onInputChange={(event, newInputValue) => {
                                    setInputValue(newInputValue);
                                    setTowerName(newInputValue)
                                    // setFlatNumbers(newValue[towerFlatDetails])
                                }}
                                id="controllable-states-demo"
                                options={towersNames}
                                style={{ position: "relative", top: -27, width: "100%" }}
                                size="small"
                                clearOnBlur={false}
                                renderInput={(params) => <MuiTextField {...params} label="" variant="outlined" />}
                            />
                        </div>
                        <div>
                            {
                                !flatField && <>
                                    <div className="formLabel-regular" style={{ marginBottom: "30px" }}>Flat Number*</div>
                                    <Autocomplete
                                        value={value2}
                                        onChange={(event, newValue) => {
                                            setValue2(newValue);
                                            setFlatNumber(newValue)
                                        }}
                                        inputValue={inputValue2}
                                        onInputChange={(event, newInputValue) => {
                                            setInputValue2(newInputValue);
                                            setFlatNumber(newInputValue)
                                        }}
                                        id="controllable-states-demo"
                                        options={flatNumbers}
                                        style={{ position: "relative", top: -27, width: "100%" }}
                                        size="small"
                                        clearOnBlur={false}
                                        renderInput={(params) => <MuiTextField {...params} label="" variant="outlined" />}
                                    />
                                </>
                            }
                            {
                                flatField && <>
                                    <div className="formLabel-regular">Flat Number*</div>
                                    <TextInput source="flat_number" value={flatNumber} onChange={(e) => setFlatNumber(e.target.value)} label="" variant="outlined" size="small" style={{ position: "relative", top: -5, width: "100%" }} />
                                </>
                            }
                        </div>
                    </>}
                </div>
                <div className="grid-250">
                    <div style={{ display: "flex", columnGap: 25 }}>
                        <div>
                            <div className="formLabel-regular" style={{ position: "relative" }}>Mobile Number*</div>
                            <TextInput source="mobile" label="" variant="outlined" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} style={{ position: "relative", top: -5 }} />
                        </div>
                        <div>
                            <div className="formLabel-regular">Gender</div>
                            <RaGenderInput source="gender" style={{ position: "relative", top: 3 }} />
                        </div>
                    </div>
                    <div>
                        <div>
                            <div className="formLabel-regular">Full Name</div>
                            <TextInput source="name" label="" variant="outlined" style={{ position: "relative", top: -5 }} />
                        </div>
                    </div>
                    <div>
                        <div>
                            <div className="formLabel-regular">Additional Information</div>
                            <TextInput source="additional_info" label="" variant="outlined" style={{ position: "relative", top: -5 }} />
                        </div>
                    </div>
                </div>

                <div className="formLabel-bold" style={{ marginTop: 5 }}>Vehicle Details</div>
                <div className="grid-250" style={{ marginTop: 8 }}>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 3 }}>Vehicle Type*</div>
                        <SelectInput variant="outlined" label="" source="vehicle_type" choices={permitVehicleTypes} optionText="name" optionValue="id" onChange={event => setVehicleType(event.target.value)} style={{ display: "flex" }} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Vehicle Number*</div>
                        <TextInput format={(value) => value && value.toUpperCase()} source="vehicle_number" label="" variant="outlined" value={vehicleNumber} onChange={(e) => {
                            const caret = e.target.selectionStart
                            const element = e.target
                            window.requestAnimationFrame(() => {
                                element.selectionStart = caret
                                element.selectionEnd = caret
                            })
                            setVehicleNumber(e.target.value)
                            setVehicleNumberOnBlur(false)
                        }} onBlur={() => setVehicleNumberOnBlur(true)} />
                    </div>
                    <div>
                        <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Chassis Number</div>
                        <TextInput source="chassis_number" label="" variant="outlined" value={chassisNumber} onChange={e => setChassisNumber(e.target.value)} />
                    </div>
                </div>

                <div className="grid-250" style={{ marginTop: 8, marginBottom: 30 }}>
                    {vehicleType === "2" && <div>
                        <p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Brand</p>
                        <MuiTextField
                            className='inputRounded'
                            size="small"
                            variant='outlined'
                            InputLabelProps={{ shrink: false }}
                            style={{ width: "250px", marginTop: "2px" }}
                            select
                            value={selectedBrand}
                            onChange={(event) => setSelectedBrand(event.target.value)}
                        >
                            {Object.keys(bikeBrands).map((val) => <MenuItem value={val}>{val}</MenuItem>)}
                        </MuiTextField>
                    </div>}

                    {vehicleType === "2" && selectedBrand && selectedBrand !== "Other" && <div>
                        <p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Model</p>
                        <MuiTextField
                            className='inputRounded'
                            size="small"
                            variant='outlined'
                            InputLabelProps={{ shrink: false }}
                            style={{ width: "250px", marginTop: "2px" }}
                            select
                            value={model}
                            onChange={(event) => setModel(event.target.value)}
                        >
                            {bikeBrands[selectedBrand] && bikeBrands[selectedBrand].length > 0 && bikeBrands[selectedBrand].map((val) => <MenuItem value={val}>{val}</MenuItem>)}
                        </MuiTextField>
                    </div>}

                    {vehicleType === "4" && <div>
                        <p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Brand</p>
                        <MuiTextField
                            className='inputRounded'
                            size="small"
                            variant='outlined'
                            InputLabelProps={{ shrink: false }}
                            style={{ width: "250px", marginTop: "2px" }}
                            select
                            value={selectedBrand}
                            onChange={(event) => setSelectedBrand(event.target.value)}
                        >
                            {Object.keys(carBrands).map((val) => <MenuItem value={val}>{val}</MenuItem>)}
                        </MuiTextField>
                    </div>}

                    {vehicleType === "4" && selectedBrand && selectedBrand !== "Other" && <div>
                        <p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Model</p>
                        <MuiTextField
                            className='inputRounded'
                            size="small"
                            variant='outlined'
                            InputLabelProps={{ shrink: false }}
                            style={{ width: "250px", marginTop: "2px" }}
                            select
                            value={model}
                            onChange={(event) => setModel(event.target.value)}
                        >
                            {carBrands[selectedBrand] && carBrands[selectedBrand].length > 0 && carBrands[selectedBrand].map((val) => <MenuItem value={val}>{val}</MenuItem>)}
                        </MuiTextField>
                    </div>}

                    {vehicleType === "6" && <div>
                        <p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Brand</p>
                        <MuiTextField
                            className='inputRounded'
                            size="small"
                            variant='outlined'
                            InputLabelProps={{ shrink: false }}
                            style={{ width: "250px", marginTop: "2px" }}
                            select
                            value={selectedBrand}
                            onChange={(event) => setSelectedBrand(event.target.value)}
                        >
                            {Object.keys(busBrands).map((val) => <MenuItem value={val}>{val}</MenuItem>)}
                        </MuiTextField>
                    </div>}

                    {vehicleType === "6" && selectedBrand && selectedBrand !== "Other" && <div>
                        <p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Model</p>
                        <MuiTextField
                            className='inputRounded'
                            size="small"
                            variant='outlined'
                            InputLabelProps={{ shrink: false }}
                            style={{ width: "250px", marginTop: "2px" }}
                            select
                            value={model}
                            onChange={(event) => setModel(event.target.value)}
                        >
                            {busBrands[selectedBrand] && busBrands[selectedBrand].length > 0 && busBrands[selectedBrand].map((val) => <MenuItem value={val}>{val}</MenuItem>)}
                        </MuiTextField>
                    </div>}
                </div>

                {allowFastag && vehicleType === "4" && !isAnprOnly && <FormControlLabel className="formLabel-regular" label="Use FASTag for permit" control={<Checkbox checked={useFastag} onChange={onUseFastagToggle} color="primary" />} style={{ width: "auto", marginBottom: 10 }} />}

                {(vehicleType === "4" && useFastag) || isAnprOnly ?
                    <FastagSelector isAnprOnly={isAnprOnly} />
                :
                    <>
                        <div className="formLabel-regular" style={{ position: "relative", top: 3 }}>ParkSmart Tag*</div>
                        {allowUnallocatedRfid ?
                            <TextInput source="rfid" label="" variant="outlined" />
                            :
                            <RaAutocompleteInput source="rfid" resourceParam="search" resourcePath="rfidInventory" filter={{ availableAtParkingFilter: accessKeyId !== '' && accessKeyId != null ? true : false, selectedParkingAccessKey: accessKeyId }} label="" getOptionValue={option => option["rfid"]} getOptionLabel={option => `${option["tag_id"]} - ${option["rfid"]}`} useAccessKeyId={false} style={{ maxWidth: 340, position: "relative", margin: "7px 0 25px" }} />
                        }
                    </>
                }

                {
                    primaryUsers.length !== 0 && userType !== "resident" && mobileNumber.length === 10 && vehicleType &&
                    <FormControlLabel
                        control={<Checkbox variant="primary" value={showSecondaryPermit} onChange={(e) => {
                            setShowSecondaryPermit(e.target.checked)
                            setLimitValidity(false)
                        }} />}
                        label="Select a Primary Permit"
                        style={{ marginBottom: showSecondaryPermit ? "0px" : "20px" }}
                    />
                }
                {
                    primaryUsers.length !== 0 && userType !== "resident" && mobileNumber.length === 10 && showSecondaryPermit && <>
                        {/* <div className="formLabel-regular">Primary Users</div> */}
                        <FormControl size="small" style={{ width: "250px", marginTop: "8px", marginBottom: showSecondaryPermit ? "20px" : "0px" }}>
                            <Select
                                variant='outlined'
                                value={primaryUser}
                                onChange={primaryUserHandler}
                            >
                                {
                                    primaryUsers.map((veh) => <MenuItem value={veh}> {veh.vehicle_type === "4" ? "4 Wheeler" : "2 Wheeler"} - {veh.vehicle_number}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                    </>
                }
                {allowStartDate ?
                    <>
                        <div className="formLabel-regular" style={{ position: "relative", top: 3 }}>Start Date*</div>
                        <RaDateInput source="registration_date" label="" placeholder="DD/MM/YYYY" style={{ marginTop: 7 }} />
                    </>
                :
                    <RaDateInput source="registration_date" label="" placeholder="DD/MM/YYYY" style={{ marginTop: 7, display: "none" }} />
                }

                {!showSecondaryPermit &&
                    <>
                        {validityToggleVisible ? 
                            <>
                                <div style={{ display: "flex", alignItems: "center", columnGap: 5, width: "100%" }}>
                                    <RaCheckBoxInput source="limit_validity" label="Validity" controlProps={{ color: "primary" }} defaultValue={limitValidity} onChangeProps={onLimitValidityToggle} />
                                    <div style={{ display: "flex", alignItems: "center", columnGap: 8, minWidth: 250 }}>
                                        <InfoOutlinedIcon style={{ fontSize: 20, color: "#bbb" }} />
                                        <div style={{ fontSize: 14, color: "#aaa" }}>{limitValidity ? "Validity of this permit is limited" : "This permit is for unlimited period of time"}</div>
                                    </div>
                                </div>
                                {limitValidity && <ValidityAmountInput />}
                            </>
                        : 
                            <>
                                <RaCheckBoxInput style={{ display: "none" }} source="limit_validity" label="Validity" controlProps={{ color: "primary" }} defaultValue={limitValidity} onChangeProps={onLimitValidityToggle} />
                                {limitValidity && <>
                                    <div className="formLabel-regular" style={{ position: "relative", top: 3 }}>Expiry Date*</div>
                                    {/* <RaDateInput source="valid_till" label="" placeholder="DD/MM/YYYY" style={{ marginTop: 7 }} expiryDate={true} maxDate={moment().utcOffset("+05:30").add(1, "month").toDate()} /> */}
                                    <DateInput variant='outlined' source="valid_till" label="" options={{ format: 'DD/MM/YYYY' }} placeholder="DD/MM/YYYY" style={{ marginTop: 7 }} defaultValue={moment().utcOffset("+05:30").add(1, "month").subtract(1, "day").toDate()} />
                                </>}
                            </>
                        }
                    </>
                }
            </SimpleForm>
        </Create>
        <ToastContainer position="bottom-right"
            autoClose={5000}
            hideProgressBar={true}
            newestOnTop={true}
            closeOnClick={true}
            rtl={false}
            pauseOnFocusLoss
            pauseOnHover={true}
            draggable
            theme="colored"
            icon={false}
        />

    </>)
};

const validateEdit = values => {
    const errors = {};

    const vehicleNumberValidation = validateVehicleNumber(values.vehicle_number);
    if (vehicleNumberValidation !== true) {
        errors.vehicle_number = vehicleNumberValidation;
    }

    if (typeof values.mobile === "string" && values.mobile.length > 0 && values.mobile.search(/^\d{10}$/g) === -1) {
        errors.mobile = 'Invalid Mobile Number';
    }
    return errors;
};

const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};
const CustomToolbar = withStyles(toolbarStyles)(props => {
    const eventTracker = UseAnalyticsEvent()
    eventTracker("PERMIT SECTION", "EDIT USER PERMIT", "User Details Changes")
    return <RaToolbar {...props}>
        <SaveButton />
    </RaToolbar>
});

const CustomEditForm = (props) => {
    const record = useRecordContext(props);
    // eslint-disable-next-line no-unused-vars
    const [allowUnallocatedRfid] = useState(sessionStorage.getItem("allow_unallocated_rfid") === "1");
    const [allowFastag] = useState(sessionStorage.getItem("allow_fastag") === "1");
    const [restrictPermits] = useState(sessionStorage.getItem("restrict_permits") === "1");
    const [vehicleNumber, setVehicleNumber] = useState("");
    const [useFastag, setUseFastag] = useState(false);
    const [chassisNumber, setChassisNumber] = useState("")
    const [userTypes, setUserTypes] = useState([]);
    const [userType, setUserType] = useState(undefined);
    const [userSubType, setUserSubType] = useState(undefined);

    const [showSubTypes, setShowSubTypes] = useState(false);
    const [isAnprOnly, setIsAnprOnly] = useState(false);
    const [limitValidity, setLimitValidity] = useState(false);
    const [validityToggleVisible, setValidityToggleVisible] = useState(false);
    const [radioValue, setRadioValue] = React.useState(null);
    const handleRadioChange = (event) => {
        setRadioValue(event.target.value)
    }


    const onLimitValidityToggle = checked => {
        setLimitValidity(checked);
    };

    const onUseFastagToggle = event => {
        setUseFastag(event.target.checked);
    };

    const onParkingSelect = async (accessKeyId) => {
        fetch(`${config.HOST_NAME}/crm/parkingAccessKeys/${accessKeyId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then((json) => {
                if (json.success) {
                    const permitUserTypes = {
                        "Society": [
                            { id: 'resident', name: 'Resident' },
                            { id: 'staff', name: 'Staff' },
                        ],
                        "Commercial": [
                            { id: 'company', name: 'Company' },
                            { id: 'staff', name: `${json.data.name} Staff` },
                            { id: 'individual', name: 'Individual' }
                        ],
                        "School": [
                            { id: 'company', name: 'Company' },
                            { id: 'staff', name: `${json.data.name} Staff` },
                            { id: 'Management', name: 'Management' }
                        ]
                    };

                    setShowSubTypes(json.data.allow_permit_sub_types);
                    setIsAnprOnly(json.data.is_anpr_only);
                    if (json.data.parking_type === "Society") {
                        setLimitValidity(false);
                        setValidityToggleVisible(false);
                    } else {
                        setValidityToggleVisible(true);
                    }

                    if (json?.data?.parking_type === "Commercial") {
                        setUserTypes(accessKeyId && accessKeyId === 1381 ? [{ id: 'company', name: 'Company' }] : permitUserTypes["Commercial"])
                        setUserType(record.user_type);
                    }
                    if (json?.data?.parking_type === "Society") {
                        setUserTypes(permitUserTypes["Society"])
                        setUserType(permitUserTypes["Society"][0].id);
                    }
                    if (json?.data?.parking_type === "School") {
                        setUserTypes(permitUserTypes["School"])
                        setUserType(permitUserTypes["School"][0].id);
                    }
                }
            })
            .catch((e) => { });
    };

    React.useEffect(() => {
        onParkingSelect(record.access_key_id)
        setLimitValidity(record.limit_validity === 1 ? true : false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <SimpleForm {...props} toolbar={<CustomToolbar fastag={useFastag} />} validate={validateEdit} redirect="list">

        <div className="formLabel-bold" style={{ marginTop: 5 }}>User Details</div>
        <div className="grid-250">
            <div>
                <div className="formLabel-regular" style={{ position: "relative", top: 10 }}>Location*</div>
                <TextInput source="parking_name" label="" variant="outlined" style={{ marginTop: 15, marginBottom: 5 }} disabled={true} />
            </div>
        </div>
        <div className="grid-250">
            <div>
                <div className="formLabel-regular">User Type*</div>
                <SelectInput variant="outlined" label="" source="user_type" choices={userTypes} optionText="name" optionValue="id" defaultValue={userType} value={userType} onChange={event => setUserType(event.target.value)} style={{ display: "flex", position: "relative", top: -3 }} />
            </div>
            {showSubTypes && userType && permitUserSubTypes[userType] && <div>
                <div className="formLabel-regular">User Sub Type*</div>
                <SelectInput variant="outlined" label="" source="user_sub_type" choices={permitUserSubTypes[userType]} optionText="name" optionValue="id" defaultValue={userSubType} value={userSubType} onChange={event => setUserSubType(event.target.value)} style={{ display: "flex", position: "relative", top: -3 }} />
            </div>}
            {userType === "company" && <div>
                <div className="formLabel-regular">Company Name*</div>
                {/* <RaAutocompleteInput source="organization_id" resourceParam="name" resourcePath="rfidOrganization" label="" getOptionValue={option => option["id"]} getOptionLabel={option => option["name"]} useAccessKeyId={true} style={{ minWidth: 280, maxWidth: 500, position: "relative", top: 3, marginBottom: 35 }} /> */}
                <CustomCompanySelector source="organization_id" resourceParam="name" resourcePath="rfidOrganization" label="" getOptionValue={option => option["id"]} getOptionLabel={option => option["name"]} useAccessKeyId={true} style={{ minWidth: 280, maxWidth: 500, position: "relative", top: 3, marginBottom: 35 }} organizationName={record.organization} />
            </div>}

            {userType === "resident" && <>
                <div>
                    <div className="formLabel-regular">Tower*</div>
                    <TextInput source="society_tower_name" label="" variant="outlined" style={{ position: "relative", top: -5, width: "100%" }} />
                </div>
                <div>
                    <div className="formLabel-regular">Flat Number*</div>
                    <TextInput source="society_flat_number" label="" variant="outlined" style={{ position: "relative", top: -5 }} />
                </div>
            </>}
        </div>
        <div className="grid-250">
            <div style={{ display: "flex", columnGap: 25 }}>
                <div>
                    <div className="formLabel-regular" style={{ position: "relative" }}>Mobile Number*</div>
                    <TextInput source="mobile" label="" variant="outlined" style={{ position: "relative", top: -5 }} />
                </div>
                <div>
                    <div className="formLabel-regular">Gender</div>
                    <RaGenderInput source="gender" style={{ position: "relative", top: 3 }} />
                </div>
            </div>
            <div>
                <div>
                    <div className="formLabel-regular">Full Name</div>
                    <TextInput source="name" label="" variant="outlined" style={{ position: "relative", top: -5 }} />
                </div>
            </div>
            <div>
                <div>
                    <div className="formLabel-regular">Additional Information</div>
                    <TextInput source="additional_info" label="" variant="outlined" style={{ position: "relative", top: -5 }} />
                </div>
            </div>
        </div>
        {/* {
            record.user_type !== "resident" && <>
                <div className="formLabel-regular">Amount*</div>
                <TextInput source="amount" label="" variant="outlined" /></>
        } */}
        <div className="formLabel-bold" style={{ marginTop: 5 }}>Vehicle Details</div>
        <div className="grid-250" style={{ marginTop: 8 }}>
            <div style={{ display: "flex", columnGap: 25 }}>

                <div>
                    <div className="formLabel-regular" style={{ position: "relative", top: 3 }}>Vehicle Type*</div>
                    <SelectInput disabled={true} variant="outlined" label="" source="vehicle_type" choices={permitVehicleTypes} optionText="name" optionValue="id" style={{ display: "flex" }} />
                </div>
                <div>
                    <div className="formLabel-regular" >Vehicle Number*</div>
                    <TextInput style={{ position: "relative", bottom: 1, marginBottom: 5 }} format={(value) => value && value.toUpperCase()} source="vehicle_number" label="" variant="outlined" value={vehicleNumber} onChange={(e) => {
                        const caret = e.target.selectionStart
                        const element = e.target
                        window.requestAnimationFrame(() => {
                            element.selectionStart = caret
                            element.selectionEnd = caret
                        })
                        setVehicleNumber(e.target.value)
                    }} />
                </div>

            </div>
            <div>
                <div>
                    <div className="formLabel-regular">Chassis Number</div>
                    <TextInput source="chassis_number" label="" variant="outlined" value={chassisNumber} onChange={e => setChassisNumber(e.target.value)} />
                </div>
            </div>
        </div>

        <CustomRfidEditFields />

        <FormControl style={{ width: "auto", marginBottom: 10 }}>
        <FormLabel >Select:</FormLabel>
        <RadioGroup
            row
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={radioValue}
            onChange={handleRadioChange}
        >
            <FormControlLabel value="pstag" control={<Radio />} label="ParkSmart Tag" />
            <FormControlLabel value="fastag" control={<Radio />} label="FASTag" />
           </RadioGroup>
        </FormControl>

        {allowFastag && record.vehicleType === "4" && !isAnprOnly && <FormControlLabel className="formLabel-regular" label="Use FASTag for permit" control={<Checkbox checked={useFastag} onChange={onUseFastagToggle} color="primary" />} style={{ width: "auto", marginBottom: 10 }} />}

        { (radioValue === "fastag") && (<FastagSelector />)}
        {radioValue === "pstag" && <>
        <div className="formLabel-regular" style={{ position: "relative", top: 3 }}>ParkSmart Tag*</div>
            <CustomRfidInventorySelector
                source="rfid"
                resourceParam="search"
                resourcePath="rfidInventory"
                filter={{ available: true }}
                label=""
                getOptionValue={option => option["rfid"]}
                getOptionLabel={option => `${option["tag_id"]} - ${option["rfid"]}`}
                useAccessKeyId={true}
                style={{ maxWidth: 340, position: "relative", margin: "7px 0 25px" }}
                permitRfid={record.rfid}
            />
    </>}

            {/* 
            {record.vehicle_type === "4" || isAnprOnly ? (
                (radioValue === "fastag") && (<FastagSelector isAnprOnly={isAnprOnly} />)
            ) : (
                radioValue === "pstag" && (
                    <>
                        <div className="formLabel-regular" style={{ position: "relative", top: 3 }}>ParkSmart Tag*</div>
                        {allowUnallocatedRfid ? (
                            <TextInput source="rfid" label="" variant="outlined" />
                        ) : (
                            <CustomRfidInventorySelector
                                source="rfid"
                                resourceParam="search"
                                resourcePath="rfidInventory"
                                filter={{ available: true }}
                                label=""
                                getOptionValue={option => option["rfid"]}
                                getOptionLabel={option => `${option["tag_id"]} - ${option["rfid"]}`}
                                useAccessKeyId={true}
                                style={{ maxWidth: 340, position: "relative", margin: "7px 0 25px" }}
                                permitRfid={record.rfid}
                            />
                        )}
                    </>
                )
            )}
            */}
    

        {!restrictPermits && <div className="formLabel-regular" style={{ position: "relative", top: 3 }}>Start Date*</div>}
        {/* <RaDateInput source="registration_date" label="" placeholder="DD/MM/YYYY" style={{ marginTop: 7 }} /> */}
       {!restrictPermits && <DateInput variant='outlined' source="registration_date" label="" options={{ format: 'DD/MM/YYYY' }} placeholder="DD/MM/YYYY" style={{ marginTop: 7 }} />}

        {!restrictPermits && validityToggleVisible && <>

            <div style={{ display: "flex", alignItems: "center", columnGap: 5, width: "100%", marginTop: 15 }}>
                <RaCheckBoxInput source="limit_validity" label="Validity" controlProps={{ color: "primary" }} defaultValue={limitValidity} onChangeProps={onLimitValidityToggle} />
                <div style={{ display: "flex", alignItems: "center", columnGap: 8, minWidth: 250 }}>
                    <InfoOutlinedIcon style={{ fontSize: 20, color: "#bbb" }} />
                    <div style={{ fontSize: 14, color: "#aaa" }}>{limitValidity ? "Validity of this permit is limited" : "This permit is for unlimited period of time"}</div>
                </div>
            </div>

            {
                limitValidity && <div style={{ marginTop: 15 }}>
                    <div className="formLabel-regular" style={{ position: "relative", top: 3 }}>Expiry Date*</div>
                    {/* <RaDateInput source="valid_till" value={expiryDate} onChange={(e) => setExpiryDate(e.target.value)} label="" placeholder="DD/MM/YYYY" style={{ marginTop: 7 }} /> */}
                    <DateInput variant='outlined' source="valid_till" label="" options={{ format: 'DD/MM/YYYY' }} placeholder="DD/MM/YYYY" style={{ marginTop: 7 }} />
                </div>
            }
        </>}
    </SimpleForm>
}

const CustomRfidEditFields = (props) => {
    const { record } = props
    const { input: { value: selectedBrand, onChange: setSelectedBrand } } = useInput({ ...props, id: "brand", source: "brand" });
    const { input: { value: model, onChange: setModel } } = useInput({ ...props, id: "model", source: "model" });
    const { input: { value: accessKeyId } } = useInput({ ...props, id: "access_key_id", source: "access_key_id" });
    const { input: { value: mobileNumber } } = useInput({ ...props, id: "mobile", source: "mobile" });
    const { input: { value: primaryUser, onChange: setPrimaryUser } } = useInput({ ...props, id: "primary_user", source: "primary_user" });
    const { input: { value: showSecondaryPermit, onChange: setShowSecondaryPermit } } = useInput({ ...props, id: "show_secondary_permit", source: "show_secondary_permit" });

    const [bikeBrands, setBikeBrands] = useState([]);
    const [carBrands, setCarBrands] = useState([]);
    const [busBrands, setBusBrands] = useState([]);

    const [primaryUsers, setPrimaryUsers] = useState([])

    const getCommonData = () => {
        fetch(
            `${config.HOST_NAME}/crm/commonData`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then(response => response.json())
            .then(json => {
                setBikeBrands({ ...json.bikeBrands, Other: ["Other"] });
                setCarBrands({ ...json.carBrands, Other: ["Other"] });
                setBusBrands({ ...json.busBrands, Other: ["—", "Other", "Unknown"] });
            })
            .catch(error => {
                console.log(error);
                notify("Check your internet connection.", "warning")

            });
    };

    const primaryUserHandler = (e) => {
        setPrimaryUser(e.target.value)
    }

    const getPrimaryUsers = () => {
        fetch(`${config.HOST_NAME}/crm/v3/primaryUsers?mobile=${mobileNumber}&access_key_id=${accessKeyId}&vehicle_type=${record.vehicle_type}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.success) {
                    setPrimaryUsers(json.data)
                }
            })
            .catch(e => {
                console.log(e)
            });
    };

    useEffect(() => {
        getCommonData()
        setShowSecondaryPermit(false)
        setPrimaryUser({})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        if (accessKeyId && mobileNumber.length === 10 && accessKeyId !== "" && mobileNumber !== "" && record.user_type !== "resident" && record.vehicle_type) {
            getPrimaryUsers()
        } else {
            setPrimaryUsers([])
            setShowSecondaryPermit(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accessKeyId, mobileNumber, record.vehicle_type])

    if (!record) return null

    return <>
        <div className="grid-250" style={{ marginTop: 8, marginBottom: 30 }}>
            {
                record.vehicle_type === "2" && bikeBrands &&
                <div>
                    <p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Brand</p>
                    <MuiTextField
                        className='inputRounded'
                        size="small"
                        variant='outlined'
                        InputLabelProps={{ shrink: false }}
                        style={{ width: "250px", marginTop: "2px" }}
                        select
                        value={selectedBrand}
                        onChange={(event) => setSelectedBrand(event.target.value)
                        }
                    >
                        {
                            Object.keys(bikeBrands).map((val) => <MenuItem value={val}>{val}</MenuItem>)
                        }
                    </MuiTextField>
                </div>
            }

            {
                record.vehicle_type === "2" && bikeBrands && selectedBrand && selectedBrand !== "Other" &&
                <div>
                    <p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Model</p>
                    <MuiTextField
                        className='inputRounded'
                        size="small"
                        variant='outlined'
                        InputLabelProps={{ shrink: false }}
                        style={{ width: "250px", marginTop: "2px" }}
                        select
                        value={model}
                        onChange={(event) => setModel(event.target.value)
                        }
                    >
                        {
                            bikeBrands[selectedBrand] && bikeBrands[selectedBrand].length > 0 && bikeBrands[selectedBrand].map((val) => <MenuItem value={val}>{val}</MenuItem>)
                        }
                    </MuiTextField>
                </div>
            }

            {
                record.vehicle_type === "4" && carBrands &&
                <div>
                    <p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Brand</p>
                    <MuiTextField
                        className='inputRounded'
                        size="small"
                        variant='outlined'
                        InputLabelProps={{ shrink: false }}
                        style={{ width: "250px", marginTop: "2px" }}
                        select
                        value={selectedBrand}
                        onChange={(event) => setSelectedBrand(event.target.value)
                        }
                    >
                        {
                            Object.keys(carBrands).map((val) => <MenuItem value={val}>{val}</MenuItem>)
                        }
                    </MuiTextField>
                </div>
            }

            {
                record.vehicle_type === "4" && carBrands && selectedBrand && selectedBrand !== "Other" &&
                <div>
                    <p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Model</p>
                    <MuiTextField
                        className='inputRounded'
                        size="small"
                        variant='outlined'
                        InputLabelProps={{ shrink: false }}
                        style={{ width: "250px", marginTop: "2px" }}
                        select
                        value={model}
                        onChange={(event) => setModel(event.target.value)
                        }
                    >
                        {
                            carBrands[selectedBrand] && carBrands[selectedBrand].length > 0 && carBrands[selectedBrand].map((val) => <MenuItem value={val}>{val}</MenuItem>)
                        }
                    </MuiTextField>
                </div>
            }

            {record.vehicle_type === "6" && busBrands && <div>
                <p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Brand</p>
                <MuiTextField
                    className='inputRounded'
                    size="small"
                    variant='outlined'
                    InputLabelProps={{ shrink: false }}
                    style={{ width: "250px", marginTop: "2px" }}
                    select
                    value={selectedBrand}
                    onChange={(event) => setSelectedBrand(event.target.value)
                    }
                >
                    {Object.keys(busBrands).map((val) => <MenuItem value={val}>{val}</MenuItem>)}
                </MuiTextField>
            </div>}

            {record.vehicle_type === "6" && busBrands && selectedBrand && selectedBrand !== "Other" && <div>
                <p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Model</p>
                <MuiTextField
                    className='inputRounded'
                    size="small"
                    variant='outlined'
                    InputLabelProps={{ shrink: false }}
                    style={{ width: "250px", marginTop: "2px" }}
                    select
                    value={model}
                    onChange={(event) => setModel(event.target.value)
                    }
                >
                    {
                        busBrands[selectedBrand] && busBrands[selectedBrand].length > 0 && busBrands[selectedBrand].map((val) => <MenuItem value={val}>{val}</MenuItem>)
                    }
                </MuiTextField>
            </div>}
        </div>

        {
            primaryUsers.length !== 0 && record.user_type !== "resident" && mobileNumber.length === 10 && record.vehicle_type &&
            <FormControlLabel
                control={<Checkbox variant="primary" value={showSecondaryPermit} onChange={(e) => {
                    setShowSecondaryPermit(e.target.checked)
                }} />}
                label="Select a Primary Permit"
                style={{ marginBottom: showSecondaryPermit ? "0px" : "20px", display: "block" }}
            />
        }
        {
            primaryUsers.length !== 0 && record.user_type !== "resident" && mobileNumber.length === 10 && showSecondaryPermit && <>
                {/* <div className="formLabel-regular">Primary Users</div> */}
                <FormControl size="small" style={{ width: "250px", marginTop: "8px", marginBottom: showSecondaryPermit ? "20px" : "0px" }}>
                    <Select
                        variant='outlined'
                        value={primaryUser}
                        onChange={primaryUserHandler}
                    >
                        {
                            primaryUsers.map((veh) => <MenuItem value={veh}> {veh.vehicle_type === "4" ? "4 Wheeler" : "2 Wheeler"} - {veh.vehicle_number}</MenuItem>)
                        }
                    </Select>
                </FormControl>
            </>
        }
    </>

}

export const NewRfidDataEdit = (props) => {
    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Updated", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }
    return (
        <Edit {...props} onFailure={onFailure} onSuccess={onSuccess} undoable={false}>
            <CustomEditForm />
        </Edit>
    );
}



function ReserveButton(props) {
    const { record, source } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));

    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const handleUpdate = (event) => {
        event.preventDefault();
        closeDialog();
        const { dispatchCrudUpdate, basePath } = props;
        const data = {
            ...record,
            reserved: record.reserved === 0 ? 1 : 0,
        };
        dispatchCrudUpdate('v2/rfidData', record.id, data, record, basePath, "/rfidData");
    };

    if (!record) return null
    return (
        <div style={{ textAlign: isSmallDevice ? "left" : "center", display: isSmallDevice ? "flex" : "block", alignItems: "center" }}>
            {/* {isSmallDevice && <Typography style={{ fontSize: 15 }}>Reserved:</Typography>} */}
            {/* <Switch disabled={props.disabled} checked={Boolean(record.enabled)} onChange={openDialog} /> */}
            <Button title='Reserved' style={{ color: record[source] ? "#18cc69" : "#B5B5B5" }} onClick={openDialog}> {record[source] ? <BeenhereIcon style={{ fontSize: isSmallDevice ? 23 : 19 }} /> : <BeenhereOutlinedIcon style={{ fontSize: isSmallDevice ? 23 : 19 }} />}</Button>

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
                <DialogContent>Are you sure you want to <strong>{record[source] ? "UnReserve" : "Reserve"}</strong> this RFID?</DialogContent>
                <DialogActions>
                    <Button color="default" onClick={closeDialog}>No</Button>
                    <Button color="secondary" onClick={handleUpdate}>Yes</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
ReserveButton.defaultProps = {
    redirect: 'list',
    undoable: false
};
const CustomReserveButton = compose(
    connect(
        null,
        { dispatchCrudUpdate: crudUpdate }
    ),
    translate
)(ReserveButton);

function ApprovalButton(props) {
    const { record, source } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));

    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const handleUpdate = (event) => {
        event.preventDefault();
        closeDialog();
        const { dispatchCrudUpdate, basePath } = props;
        const data = {
            ...record,
            enabled: !record.enabled === false ? 0 : 1,
        };
        dispatchCrudUpdate('v2/rfidData', record.id, data, record, basePath, "/rfidData");
    };

    return (
        <div style={{ textAlign: isSmallDevice ? "left" : "center", display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>
            {/* {isSmallDevice && <Typography style={{ fontSize: 15 }}>Status:</Typography>} */}
            <AntSwitch disabled={props.disabled} checked={Boolean(record.enabled)} onChange={openDialog} />

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
                <DialogContent>Are you sure you want to {record[source] ? "Deactivate" : "Activate"} this RFID?</DialogContent>
                <DialogActions>
                    <Button color="default" onClick={closeDialog}>No</Button>
                    <Button color="secondary" onClick={handleUpdate}>Yes</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
ApprovalButton.defaultProps = {
    redirect: 'list',
    undoable: false
};
const CustomApprovalButton = compose(
    connect(
        null,
        { dispatchCrudUpdate: crudUpdate }
    ),
    translate
)(ApprovalButton);

function ScheduleApprovalButton(props) {
    const { record, source } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));

    const [dialogVisible, setDialogVisible] = React.useState(false);
    const [toggle, setToggle] = useState("false");
    const [scheduledDate, setScheduledDate] = useState(Date.now())

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };


    const onOptionChange = event => {
        setToggle(event.target.value);
    }

    const handleUpdate = (event) => {
        event.preventDefault();
        closeDialog();
        const { dispatchCrudUpdate, basePath } = props;
        if (!record.valid_till) {
            const data = {
                ...record,
                enabled: scheduledDate && toggle === "true" ? record.enabled : !record.enabled === false ? 0 : 1,
                valid_till: scheduledDate && toggle === "true" ? moment(scheduledDate).utcOffset('+05:30').format("YYYY-MM-DD HH:mm:ss") : null,
                limit_validity: scheduledDate && toggle === "true" ? true : false
            };
            dispatchCrudUpdate('v2/rfidData', record.id, data, record, basePath, "/rfidData");
        } else {
            const data = {
                ...record,
                enabled: 1,
                valid_till: null,
                limit_validity: false
            };
            dispatchCrudUpdate('v2/rfidData', record.id, data, record, basePath, "/rfidData");
        }
    };

    if (record.valid_till && record.limit_validity && record.user_type === 'resident' && record.valid_till > moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59")) return null

    return (
        <div style={{ textAlign: isSmallDevice ? "left" : "center", display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>
            {/* {isSmallDevice && <Typography style={{ fontSize: 15 }}>Status:</Typography>} */}
            <AntSwitch disabled={props.disabled} checked={record.valid_till ? false : Boolean(record.enabled)} onChange={openDialog} />

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
                {
                    !record.valid_till ?
                        <DialogContent>
                            <div style={{ display: 'flex', alignItems: "center" }}>
                                <img src={vehicleSvgs[record.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8, overflow:"visible" }} alt={record.vehicle_type_label} />
                                <Typography>{record.vehicle_number}</Typography>
                            </div>
                            <RadioGroup
                                row
                                value={toggle}
                                onChange={onOptionChange}
                                style={{ marginTop: 20 }}
                            >
                                <FormControlLabel
                                    value="false"
                                    control={<Radio />}
                                    label="Deactivate"
                                    style={{ flex: 1 }}
                                />
                                <FormControlLabel
                                    value="true"
                                    control={<Radio />}
                                    label="Schedule For Now"
                                    style={{ flex: 1 }}
                                />


                            </RadioGroup>

                            {
                                toggle === "true" &&
                                <div style={{ marginTop: 20 }}>
                                    <Typography>This permit will be deactivate later on.</Typography>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <DateTimePicker
                                            ampm
                                            value={scheduledDate}
                                            onChange={datetime => setScheduledDate(datetime)}
                                            label="Select a Date"
                                            inputVariant="outlined"
                                            TextFieldComponent={(props) => <MuiTextField {...props} size="small" />}
                                            ToolbarComponent={DateTimePickerToolbar}
                                            format="dd/MM/yyyy hh:mm a"
                                            style={{ display: "block", marginTop: "20px" }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            }

                            {
                                toggle === "false" &&
                                <div style={{ marginTop: 20 }}>Are you sure you want to {record[source] ? "Deactivate" : "Activate"} this RFID?</div>
                            }

                        </DialogContent>
                        :
                        <DialogContent>
                            <div style={{ display: 'flex', alignItems: "center" }}>
                                <img src={vehicleSvgs[record.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8 }} alt={record.vehicle_type_label} />
                                <Typography>{record.vehicle_number}</Typography>
                            </div>
                            <div style={{ marginTop: 20 }}>Are you sure you want to Activate this RFID?</div>
                        </DialogContent>
                }
                <DialogActions>
                    <Button color="default" onClick={closeDialog}>Cancel</Button>
                    <Button color="secondary" onClick={handleUpdate}>Okay</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
ScheduleApprovalButton.defaultProps = {
    redirect: 'list',
    undoable: false
};
const CustomScheduleApprovalButton = compose(
    connect(
        null,
        { dispatchCrudUpdate: crudUpdate }
    ),
    translate
)(ScheduleApprovalButton);

function ExitVehicleButton(props) {
    const { record } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));
    //const notify = useNotify();

    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const exitVehicle = (event) => {
        event.preventDefault();
        closeDialog();
        const params = {
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/rfidData/${record["id"]}/exit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params)
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify("Vehicle Exit Recorded", "success");
                } else {
                    notify(json.message, "warning");
                }
            })
            .catch(error => {
                notify("Something went wrong", "warning");
                console.log(error);
            });
    };

    return (
        <div style={{ textAlign: isSmallDevice ? "left" : "center", display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: isSmallDevice ? 0 : 1 }}>
            <RaButton title='Exit' disabled={props.disabled} label={false} color="secondary" onClick={openDialog}><ExitToAppIcon /></RaButton>

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
                <DialogContent>Are you sure you want to exit this Vehicle?</DialogContent>
                <DialogActions>
                    <Button color="default" onClick={closeDialog}>No</Button>
                    <Button color="secondary" onClick={exitVehicle}>Yes</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

function RechargeButton(props) {
    const { record, amount, accessKeyId, setAmount } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));
    //const notify = useNotify();
    const refresh = useRefresh();
    const classes = useStyles();
    const { setIsChange } = useContext(ContextProvider);

    const [loading, setLoading] = useState(false);
    const [paymentFailedDialog, setPaymentFailedDialog] = useState(null);
    const [companyUser] = useState(sessionStorage.getItem("company_user") === "1");
    const [showRfidRecharge] = useState(sessionStorage.getItem("show_rfid_recharge") === "1");
    const [paymentMethodDialogVisible, setPaymentMethodDialogVisible] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState(null);



    const handleAmountChange = event => {
        if (!isNaN(event.target.value)) {
            setAmount(event.target.value);
        }
    };

    const handleAmountBlur = event => {
        if (event.target.value === "") {
            setAmount("0");
        }
    };



    const closePaymentFailedDialog = () => {
        setPaymentFailedDialog(null);
    };

    const rechargePermit = async (event) => {
        event.preventDefault();
        if (amount === "" || isNaN(amount) || !(amount >= 0)) {
            return notify("Invalid Amount", "warning");
        }
        if (paymentMethod == null) {
            return notify("Please select a payment method", "warning");
        }

        if (paymentMethod === "Cash") {
            if (record.ids.length === 1) {
                rechargePermitCash(event);
            }
            if (record.ids.length > 1) {
                bulkRechargePermitCash(event)
            }

        } else {
            if (record.ids.length === 1) {
                singleRecharge(event);
            }
            if (record.ids.length > 1) {
                bulkRechargePermitDigital(event)
            }

        }
    };

    // single recharge CASH
    const rechargePermitCash = (event) => {
        event.preventDefault();
        closePaymentModeDialog();

        setLoading(true);
        const rfidId = record.ids[0];
        fetch(`${config.HOST_NAME}/crm/rfidData/${rfidId}/recharge`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ amount: amount })
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false);
                if (json.success) {
                    notify(json.message, "success");
                    refresh();
                } else {
                    notify(json.message, "warning");
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                notify("Internal Server Error", "warning");
            });
    };

    //single Recharge DIGITAL
    const singleRecharge = (event) => {
        const updateRfidPaymentStatus = async (transactionId, paymentStatus, remarks) => {
            const rfidId = record.ids[0];
            fetch(`${config.HOST_NAME}/crm/rfidData/${rfidId}/payment/${transactionId}/status`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ payment_status: paymentStatus, remarks: remarks })
            });
        };

        const rechargePermitDigital = async (event) => {
            event.preventDefault();
            closePaymentFailedDialog();
            closePaymentModeDialog();

            setLoading(true);
            const rfidId = record.ids[0];
            fetch(`${config.HOST_NAME}/crm/rfidData/${rfidId}/initiateRfidRecharge`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ amount: amount })
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    if (json.success) {
                        const order = json.data.order;
                        var options = {
                            description: 'SMARTag Charges',
                            currency: order.currency,
                            key: config.RAZOR_PAY_KEY_ID,
                            amount: order.amount,
                            name: 'ParkSmart',
                            order_id: order.id,
                            notes: {
                                rfid: rfidId,
                                parking_name: json.data.parking_name
                            },
                            theme: {
                                color: customTheme.palette.primary.main
                            },
                            modal: {
                                ondismiss: () => {
                                    setLoading(false);
                                    const description = "Payment is cancelled by user";
                                    setPaymentFailedDialog(description);
                                    updateRfidPaymentStatus(json.data.transaction_id, "CANCELLED", description);
                                }
                            },
                            handler: checkoutData => {
                                fetch(`${config.HOST_NAME}/crm/rfidData/${rfidId}/verifyRfidRecharge`, {
                                    method: 'POST',
                                    headers: {
                                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                                        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({ ...checkoutData, transaction_id: json.data.transaction_id }),
                                })
                                    .then(response => {
                                        saveTokens(response)
                                        return response.json()
                                    })
                                    .then(json => {
                                        setLoading(false);
                                        if (json.success) {
                                            notify("Payment Successful", "success");
                                            refresh();
                                        } else {
                                            setPaymentFailedDialog(json.message);
                                        }
                                    })
                                    .catch((error) => {
                                        setLoading(false);
                                        setPaymentFailedDialog("Could not verify Payment");
                                    });
                            },
                        }
                        const razorpay = new window.Razorpay(options);
                        razorpay.on('payment.failed', function ({ error }) {
                            setLoading(false);
                            let description, status;
                            if (isJsonString(error.description)) {
                                const errorObj = JSON.parse(error.description);
                                if (errorObj.error) {
                                    description = errorObj.error.description;
                                    status = errorObj.error.reason;
                                } else {
                                    description = errorObj.description;
                                    status = errorObj.reason;
                                }
                            } else {
                                description = error.description;
                            }
                            setPaymentFailedDialog(description);
                            updateRfidPaymentStatus(json.data.transaction_id, status === "payment_cancelled" ? "CANCELLED" : "FAILED", description);
                        });

                        razorpay.open();
                    } else {
                        setLoading(false);
                        notify(json.message, "warning");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    setLoading(false);
                    notify("Check your internet connection", "warning");
                });
        };

        rechargePermitDigital(event)
    }

    // bulk recharge DIGITAL
    const bulkRechargePermitDigital = (event) => {
        const updateRfidPaymentStatus = async (transactionId, paymentStatus, remarks) => {
            const rfidIds = record.ids;
            fetch(`${config.HOST_NAME}/crm/v3/rfidData/status`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ payment_status: paymentStatus, remarks: remarks, transactionId: transactionId, rfidIds: rfidIds })
            });
        };

        const rechargePermitDigital = async (event) => {
            event.preventDefault();
            closePaymentFailedDialog();
            closePaymentModeDialog();

            setLoading(true);
            const rfidIds = record.ids;
            fetch(`${config.HOST_NAME}/crm/v3/rfidData/initiateRfidRecharge`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ amount: amount, access_key_id: accessKeyId, rfidIds: rfidIds })
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    if (json.success) {
                        const order = json.data.order;
                        var options = {
                            description: 'SMARTag Charges',
                            currency: order.currency,
                            key: config.RAZOR_PAY_KEY_ID,
                            amount: order.amount,
                            name: 'ParkSmart',
                            order_id: order.id,
                            notes: {
                                rfid: rfidIds[0],
                                parking_name: json.data.parking_name
                            },
                            theme: {
                                color: customTheme.palette.primary.main
                            },
                            modal: {
                                ondismiss: () => {
                                    setLoading(false);
                                    const description = "Payment is cancelled by user";
                                    setPaymentFailedDialog(description);
                                    updateRfidPaymentStatus(json.data.transaction_id, "CANCELLED", description);
                                }
                            },
                            handler: checkoutData => {
                                fetch(`${config.HOST_NAME}/crm/v3/rfidData/verifyRfidRecharge`, {
                                    method: 'POST',
                                    headers: {
                                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                                        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({ ...checkoutData, transaction_id: json.data.transaction_id, rfidIds: rfidIds }),
                                })
                                    .then(response => {
                                        saveTokens(response)
                                        return response.json()
                                    })
                                    .then(json => {
                                        setLoading(false);
                                        if (json.success) {
                                            notify("Payment Successful", "success");
                                            refresh();
                                        } else {
                                            setPaymentFailedDialog(json.message);
                                        }
                                    })
                                    .catch((error) => {
                                        setLoading(false);
                                        setPaymentFailedDialog("Could not verify Payment");
                                    });
                            },
                        }
                        const razorpay = new window.Razorpay(options);
                        razorpay.on('payment.failed', function ({ error }) {
                            setLoading(false);
                            let description, status;
                            if (isJsonString(error.description)) {
                                const errorObj = JSON.parse(error.description);
                                if (errorObj.error) {
                                    description = errorObj.error.description;
                                    status = errorObj.error.reason;
                                } else {
                                    description = errorObj.description;
                                    status = errorObj.reason;
                                }
                            } else {
                                description = error.description;
                            }
                            setPaymentFailedDialog(description);
                            updateRfidPaymentStatus(json.data.transaction_id, status === "payment_cancelled" ? "CANCELLED" : "FAILED", description);
                        });

                        razorpay.open();
                    } else {
                        setLoading(false);
                        notify(json.message, "warning");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    setLoading(false);
                    notify("Check your internet connection", "warning");
                });
        };

        rechargePermitDigital(event)
    }

    //bulk recharge CASH
    const bulkRechargePermitCash = (event) => {
        event.preventDefault();
        closePaymentModeDialog();

        setLoading(true);
        const rfidIds = record.ids;
        fetch(`${config.HOST_NAME}/crm/v3/rfidData/recharge`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ amount: amount, rfidIds: rfidIds, access_key_id: accessKeyId })
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false);
                if (json.success) {
                    notify(json.message, "success");
                    refresh();
                } else {
                    notify(json.message, "warning");
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                notify("Internal Server Error", "warning");
            });
    };



    const openPaymentModeDialog = () => {
        setPaymentMethodDialogVisible(true);
    };

    const closePaymentModeDialog = () => {
        setPaymentMethodDialogVisible(false);
    };


    // const getAmount = () => {

    //     if (record.ids.length !== 0) {
    //         fetch(`${config.HOST_NAME}/crm/v3/rfidAmountRequest`, {
    //             method: 'POST',
    //             headers: {
    //                 Authorization: `Bearer ${sessionStorage.getItem('token')}`,
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify({
    //                 rfIds: record.ids
    //             }),
    //         })
    //             .then(response => response.json())
    //             .then(json => {

    //                 if (json.success) {
    //                     let data = json.data
    //                     console.log(data)
    //                     let totalBulkAmount = 0
    //                     let access_key_id = data[0].access_key_id
    //                     for (let i in data) {

    //                         if (!data[i].limit_validity && access_key_id !== data[i].access_key_id) {
    //                             notify("Cannot Recharge this permit", "warning");
    //                             return;
    //                         }
    //                         if (record.ids.length === 1) {
    //                             if (data[i].primary_permit_id) {
    //                                 setPaymentMethodDialogVisible(false);
    //                                 notify(`Please recharge your primary vehicle ${data[i].vehicle_number} instead`, "info");
    //                                 return;
    //                             }
    //                         } if (record.ids.length > 1) {
    //                             if (data[i].primary_permit_id) {
    //                                 setPaymentMethodDialogVisible(false);
    //                                 notify(`Secondary Permit found in Bulk Recharge. Please remove it`, "info");
    //                                 return;
    //                             }
    //                         }
    //                         //parking flag
    //                         if (true) {
    //                             if (data[i].valid_till > moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59")) {
    //                                 setPaymentMethodDialogVisible(false);
    //                                 notify(`Please kindly recharge after ${moment(data[i].valid_till).utcOffset("+05:30").format("DD-MM-YYYY")}`, "info");
    //                                 return;
    //                             }
    //                         }

    //                         totalBulkAmount += data[i].amount
    //                     }
    //                     setAmount(totalBulkAmount)
    //                     setAccessKeyId(access_key_id)
    //                 } else {
    //                     notify(json.message, "warning");
    //                 }
    //             })
    //             .catch(error => {
    //                 notify("Something went wrong", "warning");
    //                 console.log(error);
    //             });
    //     }
    // }

    // useEffect(() => {
    //     getAmount()
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [paymentMethodDialogVisible]);

    return (
        <div style={{ textAlign: isSmallDevice ? "left" : "center", display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>
            <RaButton label="Recharge" color="secondary" onClick={() => {
                setIsChange(false)
                if (companyUser && record.ids.length === 1) {
                    singleRecharge()
                }
                else if (companyUser && record.ids.length > 1) {
                    bulkRechargePermitDigital()
                } else {
                    openPaymentModeDialog()
                }
            }}><PaymentIcon /></RaButton>

            <Portal>
                <Dialog open={paymentMethodDialogVisible} onClose={closePaymentModeDialog} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle style={{ color: customTheme.palette.secondary.main }}><div style={{ fontSize: 16, textAlign: "center" }}>{record.ids.length === 1 ? "Recharge" : record.ids.length > 1 ? "Bulk Recharge" : null}</div></DialogTitle>
                    <DialogContent style={{ fontSize: 14, marginTop: 0, marginBottom: 0 }}>
                        <MuiTextField value={amount} onChange={handleAmountChange} onBlur={handleAmountBlur} label="Amount" variant="outlined" size="small" disabled={showRfidRecharge || record.ids.length > 1 ? true : false} />
                        <RadioGroup row value={paymentMethod} onChange={event => setPaymentMethod(event.target.value)} style={{ columnGap: 15, marginTop: 10 }}>
                            <FormControlLabel className="formLabel-regular" value="Cash" control={<Radio color="primary" />} label="Cash" />
                            <FormControlLabel className="formLabel-regular" value="Digital" control={<Radio color="primary" />} label="Digital" />
                        </RadioGroup>
                    </DialogContent>

                    <DialogActions style={{ display: "flex", justifyContent: "space-evenly" }}>
                        <Button className={classes.dialogButton} variant="outlined" color="default" onClick={closePaymentModeDialog}>Cancel</Button>
                        <Button disableElevation className={classes.dialogButton} variant="contained" color="secondary" onClick={rechargePermit}>Recharge</Button>
                    </DialogActions>
                </Dialog>
            </Portal>

            {loading && <Portal>
                <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "#0001", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress size={50} />
                </div>
            </Portal>}

            <Portal>
                <Dialog open={!!paymentFailedDialog} onClose={closePaymentFailedDialog} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle style={{ color: customTheme.palette.error.main }}><div style={{ fontSize: 16, textAlign: "center" }}>Payment Failed!</div></DialogTitle>
                    <DialogContent style={{ fontSize: 14, marginTop: 0, marginBottom: 10 }}>Description: {paymentFailedDialog}</DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "space-evenly" }}>
                        <Button className={classes.dialogButton} variant="outlined" color="default" onClick={closePaymentFailedDialog}>Cancel</Button>
                        <Button disableElevation className={classes.dialogButton} variant="contained" color="secondary" onClick={record.ids.length === 1 ? singleRecharge : record.ids.length > 1 ? bulkRechargePermitDigital : null}>Retry</Button>
                    </DialogActions>
                </Dialog>
            </Portal>
        </div>
    );
}

// const statusOptions = [
//     { value: -1, label: "Pending" },
//     { value: 1, label: "Accepted" },
//     { value: 0, label: "Declined" },
// ];

const RFID_REQUEST_COLUMNS = {
    "Parking Name": false,
    "RFID": true
};

const defaultRequestFilter = [
    {
        filterType: "Organization",
        value: "",
        id: ""
    },
    {
        filterType: "Vehicle",
        value: "",
        id: ""
    },
    {
        filterType: "Status",
        value: "Pending",
        id: 1
    },
    {
        filterType: "Display Columns",
        value: "",
        id: ""
    }
]
export const RfidRequestsList = props => {
    const classes = useStyles();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const location = useLocation()
    const queryParams = queryString.parse(props.location.search);
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    const listDataRef = useRef();
    const { permissions } = usePermissions();

    const [prevSearch] = useState(queryParams && queryParams.vehicle_number ? { inputSearch: queryParams.vehicle_number, type: "Vehicle Number" } : sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : "")
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [showRfidColumn] = useState(sessionStorage.getItem("show_rfid_column") === "1");
    const [showCompany] = useState(sessionStorage.getItem("show_rfid_company") === "1");
    const [showFlatDetails] = useState(sessionStorage.getItem("show_flat_details") === "1");
    const [showTagColumn] = useState(sessionStorage.getItem("show_tag_column") === "1");
    const [hideMobileNumber] = useState(sessionStorage.getItem("hide_mobile_number") === "1");
    //const [vehicleTypes, setVehicleTypes] = React.useState(Object.keys(featuresData.vehicle_type).map(type => ({ type, label: featuresData.vehicle_type[type].label, name: featuresData.vehicle_type[type].name })));
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [displayColumns, setDisplayColumns] = useState(localStorage.getItem("rfidRequestColumns") ? JSON.parse(localStorage.getItem("rfidRequestColumns")) : RFID_REQUEST_COLUMNS);

    
    const [privacyFeatureAccess, setPrivacyFeatureAccess] = useState(sessionStorage.getItem('privacy_feature_access') === "1")

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));


    let searchStateObject = [
        { name: "Vehicle Number", showSearch: true },
        { name: "Name", showSearch: true },
        { name: "Mobile", showSearch: true },
        { name: "Tower Name", showSearch: (showFlatDetails || permissions === "admin") },
        { name: "Flat Number", showSearch: (showFlatDetails || permissions === "admin") },
    ]
    let searchTypeState = getSearchState(searchStateObject)
    const [search, setSearch] = useState(prevSearch.inputSearch)
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
    //let valueByFilterInitState = [{ filterType: "Organization", value: "", id: "" }, { filterType: "Vehicle", value: "", id: "" }, { filterType: "Action", value: "", id: "" }, { filterType: "Parking Name", value: "", id: "" }, { filterType: "Parking Zones", value: "", id: "" }]
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : defaultRequestFilter)
    let filterTypesInitState = [
        {
            resourcePath: "rfidOrganization",
            filterType: "Organization",
            dataList: [],
            searchList: [],
            listType: "Dynamic",
            resourceParam: "name",
            source: "organization_id",
            showFilter: showCompany
        },
        {
            filterType: "Vehicle",
            dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Status",
            dataList: [{ name: "Pending", id: 1 }, { name: "Accepted", id: 2 }, { name: "Declined", id: 3 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Display Columns",
            dataList: { "Parking Name": false, "RFID": false },
            listType: "CheckboxStatic",
            caseType: "CheckboxTypeStatic",
            showFilter: true,
            filterFormat: "Checkbox"
        },

    ]

    let settingFilterFormat = {}
    // Add more condition based on the filters
    if (filterListValue) {
        for (let val in filterListValue) {
            if (filterListValue[val].filterType === "Organization") {
                settingFilterFormat = { ...settingFilterFormat, organization_id: filterListValue[val].id ? filterListValue[val].id : undefined }
            }
            if (filterListValue[val].filterType === "Vehicle") {
                settingFilterFormat = { ...settingFilterFormat, vehicle_type: filterListValue[val].id ? filterListValue[val].id : undefined }
            }
            if (filterListValue[val].filterType === "Status") {
                settingFilterFormat = { ...settingFilterFormat, status: filterListValue[val].value === "Accepted" ? 1 : filterListValue[val].value === "Declined" ? 0 : filterListValue[val].value === "Pending" ? -1 : undefined }
            }
        }
    }

    const filter = { ...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const getExportFile = (fileType) => {
        const {current : {total, currentSort, filterValues}} = listDataRef
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/rfidRequests?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `${currentParking && currentParking.name ? currentParking.name : ""} Permit Request Data.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    const getPDF = () => {
        getExportFile("pdf");
    };

    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: isSmallDevice ? "0 16px" : 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />
            }

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} defaultColumns={RFID_REQUEST_COLUMNS} storageKey="rfidRequestColumns" displayColumns={displayColumns} setDisplayColumns={setDisplayColumns} />
            {hideMobileNumber && <PrivacyPasswordAuthentication privacyFeatureAccess={privacyFeatureAccess} setPrivacyFeatureAccess={setPrivacyFeatureAccess} />}
            <CustomExportButton getCSV={getExcelFile} getPDF={getPDF} disabled={listDataRef.current && listDataRef.current.total === 0} />
        </div>

        <List
            {...props}
            style={{marginTop: 20}}
            title="Permit Requests"
            bulkActionButtons={<RfidRequestBulkActionButtons/>}
            sort={{ field: 'created_on', order: 'DESC' }}
            filter={filter}
            empty={false}
            actions={false}
            pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}} />}
        >
            {isSmallDevice ?
                <SimpleList
                    leftIcon={row => row.vehicle_type ? <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ padding: 4, width: 28, height: 28, marginTop: 8, marginRight: 10, overflow:"visible" }} /> : undefined}
                    primaryText={record => hideVehicleNumber(record["vehicle_number"])}
                    secondaryText={record => (<div>
                        {showRfidColumn && <div style={{ color: "#444" }}>{record["rfid"]}</div>}
                        <div style={{ color: customTheme.palette.secondary.main }}>{record["parking_name"]}</div>
                        <div>{record["name"] ? `Name: ${hideName(record["name"])}` : ""}</div>
                        {hideMobileNumber && privacyFeatureAccess === null ? <FunctionField source="mobile" label="Mobile No." render={record => {
                            return record["mobile"] !== null ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}><span style={{ color: "#5a5a5a", marginRight: 5 }}>Mob No: </span>{hideMobileMask(record["mobile"])}</div> : ""
                        }} />
                            : <FunctionField source="mobile" label="Mobile No." render={record => record["mobile"] !== null ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}><span style={{ color: "#5a5a5a", marginRight: 5 }}>Mob No: </span>{`${hideMobileMask(record["mobile"])}`}</div> : ""} />
                        }
                        <div>{record["chassis_number"] !== "null" ? `Chassis No: ${record["chassis_number"]}` : ""}</div>
                        {showTagColumn && <FunctionField label="Tag" render={renderTagImageForMob} />}
                        <div>Requested At: {renderTime(record["created_on"])}</div>
                        <div style={{ textTransform: "capitalize" }}>{record["user_type"] ? `User Type: ${record["user_type"]}` : ""}</div>
                        <div>{record["is_fastag"] ? `FasTag: Yes` : "FasTag: No"}</div>
                        {showCompany && <div>{record["organization_name"] ? `Company Name: ${record["organization_name"]}` : ""}</div>}
                        {(!showCompany || showFlatDetails || permissions === "admin") && record["society_tower_name"] && <div>Tower: {record["society_tower_name"]}</div>}
                        {(!showCompany || showFlatDetails || permissions === "admin") && record["society_flat_number"] && <div>Flat No: {record["society_flat_number"]}</div>}
                        {!viewOnly && <RequestStatusField {...props} record={record} label="Status" source="status" />}
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid className={!viewOnly ? 'rfidRequestDataGrid' : ''} component={ScrollableTable}>
                    <RaGenderField source="gender" label="" />
                    <FunctionField source='name' label='Name' render={(record) => record && record.name ? hideName(record.name) : '-'} />
                    {/* <FunctionField label="Name" source='name' render={(record) => record &&
                        <RenderParkingName record={record} />
                    } /> */}
                    {/* <TextField source="mobile" label="Mobile No." /> */}
                    {hideMobileNumber && privacyFeatureAccess === null ? <FunctionField source="mobile" label="Mobile No." render={record => {
                        return record ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>{record && record["mobile"] ? hideMobileMask(record["mobile"]) : "-"}</div> : "-"
                    }} />
                        : <FunctionField source="mobile" label="Mobile No." render={record => record && record["mobile"] ? hideMobileMask(record["mobile"]) : "-"} />
                    }
                    <FunctionField source="vehicle_number" label="Vehicle Number" render={record => record && record.vehicle_number && renderVehicles(record, record.vehicle_id, "verifyVehicles")} />
                    <FunctionField source="chassis_number" label="Chassis Number" render={record => record && record.chassis_number ? record["chassis_number"] : "-"} />
                    <FunctionField
                        source="vehicle_type"
                        label="Type"
                        render={record => record && renderVehicleType(record)}
                        sortable
                    />
                    {showTagColumn && <FunctionField label="Tag" render={record => record && renderTagImageDataGrid(record)} />}
                    {displayColumns["RFID"] && showRfidColumn && <FunctionField source="rfid" label="RFID" render={record => record && record.rfid ? record.rfid : "-"} />}
                    <FunctionField source="created_on" label="Requested at" render={record => record && renderTime(record["created_on"])} sortable={true} />
                    <FunctionField source="user_type" label="User Type" style={{ textTransform: "capitalize" }} render={record => record && record.user_type ? record.user_type : "-"} />
                    <FunctionField source="user_sub_type" label="Sub Type" style={{ textTransform: "capitalize" }} render={record => record && record.user_sub_type ? record.user_sub_type : "-"} />
                    {(showCompany || permissions === "admin") && <FunctionField source="organization" label="Company" style={{ textTransform: "capitalize" }} render={record => record && record.organization ? record.organization : "-"} />}
                    {(!showCompany || showFlatDetails || permissions === "admin") && <FunctionField source="society_tower_name" label="Tower" style={{ textTransform: "capitalize" }} render={record => record && record.society_tower_name ? record.society_tower_name : "-"} />}
                    {(!showCompany || showFlatDetails || permissions === "admin") && <FunctionField source="society_flat_number" label="Flat Number" style={{ textTransform: "capitalize" }} render={record => record && record.society_flat_number ? record.society_flat_number : "-"} />}
                    <FunctionField source="is_fastag" label="FASTag" render={record => record && record["rfid"] != null && record["rfid"] !== "" ? (record["is_fastag"] ? "Yes" : "No") : "-"} />
                    {displayColumns["Parking Name"] && <TextField source="parking_name" label="Parking Name" />}

                    <FunctionField className="ListIconsContainerRfidRequest" render={record => record &&
                        <div className="ListIcons">
                            <div>
                                <RequestStatusField record={record} source={"status"} queryParams={queryParams} />
                            </div>
                        </div>
                    } />
                </Datagrid >
            }
        </List >
    </div >
};

const FastagSelectorForRequest = (props) => {

    const { rfid, setRfid, record, chassisNumber } = props
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    //const notify = useNotify();

    const [fastagData, setFastagData] = useState([]);
    const [fastagLoading, setFastagLoading] = useState(false);
    const [isFastTag, setisFastTag] = useState(false);
    const [value, setValue] = React.useState();
    const [testValue, setTestValue] = useState("")

    const handleChange = (event) => {
        setTestValue(event.target.value)
        setValue(event.target.value);
        onRfidInputChange(event)
    };

    const getFastags = () => {
        setFastagLoading(true);
        fetch(`${config.HOST_NAME}/crm/fastags?vehicle_number=${record.vehicle_number}&chassis_number=${record && record.chassis_number ? record.chassis_number : chassisNumber}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setFastagLoading(false);
                if (json.success) {

                    const getFastagIssuerIdArray = (tagsArray) => {
                        let onlyTagsArray = tagsArray.map((val) => {
                            let tagIdBin = "";
                            for (let i = 0; i < val.TAGID.length; i++) {
                                tagIdBin += (parseInt(val.TAGID[i], 16).toString(2)).padStart(4, "0");
                            }
                            const issuerId = parseInt(tagIdBin.substr(43, 20), 2).toString();
                            const tagName = fastagIssuers[issuerId] ? fastagIssuers[issuerId] : "Unknown"
                            return { ...val, tagName: tagName }
                        })

                        return onlyTagsArray
                    };
                    const issuerIdArray = getFastagIssuerIdArray(json.data);
                    setFastagData(issuerIdArray);
                    setValue(issuerIdArray[0].TAGID)
                    setRfid(issuerIdArray[0].TAGID);
                    setTestValue(issuerIdArray[0].TAGID)

                } else {
                    notify(json.message, "warning");
                }
            })
            .catch(error => {
                setFastagLoading(false);
                notify("Something went wrong", "warning");
                console.log(error);
            });
    };

    function fastagHandler(epcString) {
        if (epcString.search(/^34/g) !== -1) {
            return parseInt(parseInt(epcString, 16).toString(2).padStart(epcString.length * 4, "0").substring(14, 38), 2) === 8907272
        } else {
            return epcString.search(/^918907048/g) !== -1
        }
    };
    const onRfidInputChange = event => {
        setRfid(event.target.value);
        setisFastTag(fastagHandler(event.target.value))
    };

    const fasTagStatusRender = (tag) => {

        if (tag) {
            if (tag.length > 6) {
                let tagsArr = tag.split(",")

                return tagsArr[0]
            }
            return tag
        }
        return ""
    }

    // useEffect(() => {
    //     onRfidChange("");
    // }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return <div style={{ marginTop: 15, marginBottom: 0, width: "100%" }}>
        {/* <div style={{ marginBottom: 20, display: "flex", alignItems: "center", columnGap: 25 }}>
            <Button variant="contained" color="secondary" onClick={getFastags} disableElevation style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", padding: "8px 4%", minWidth: 120 }}>{fastagData ? "Refresh" : "Fetch Fastag"}</Button>
            {fastagLoading && <CircularProgress color="secondary" size={25} />}
        </div> */}
        <div style={{ display: "flex", justifyContent: "start", alignItems: "center", columnGap: 20 }}>
            <div style={{ display: 'flex', alignItems: "center" }}>
                <img src={vehicleSvgs[record.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8 }} alt={record.vehicle_type_label} />
                <p style={{ fontFamily: "Poppins-Medium", color: "#707683", fontSize: 15, textTransform: "uppercase" }}>{record.vehicle_number}</p>

            </div>

            {
                record.chassis_number && record.chassis_number !== null && record.chassis_number !== "" && <div style={{ display: 'flex', alignItems: "center" }}>
                    <p style={{ fontFamily: "Poppins-Medium", color: "#212121", fontSize: 15, marginRight: 8 }}>Chassis Number:</p>
                    <p style={{ fontFamily: "Poppins-Medium", color: "#707683", fontSize: 15, textTransform: "uppercase" }}>{record.chassis_number}</p>
                </div>
            }
        </div>


        {fastagData.length !== 0 ?
            <FormControl>
                <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={testValue}
                    onChange={handleChange}
                    defaultValue={fastagData[0].TAGID}
                    row
                >
                    <Grid container spacing={isSmallDevice ? 1 : 3}>
                        {
                            fastagData.map((tags) => {
                                return (
                                    <Grid item xs={isSmallDevice ? 12 : 6}>
                                        <div onClick={() => handleChange({ target: { value: tags.TAGID } })} style={{ position: "relative", width: 250, border: tags["TAGID"] === value ? "2px solid #18cc69" : "2px solid #D1DBE8", borderRadius: 12, margin: "0px 0px 20px 0px" }}>
                                            <div style={{ backgroundImage: `url(${FasTagCard})`, borderRadius: 10, height: "147px", backgroundRepeat: "no-repeat", backgroundSize: "100%", position: "relative" }}>
                                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                                    <FormControlLabel color="primary" className="formControlLabel-small" value={tags["TAGID"]} control={<Radio color="primary" size="small" />} label={
                                                        <Box component="div" fontSize={14}>
                                                            {tags["TAGID"] === value ? "Selected" : "Select"}
                                                        </Box>
                                                    } style={{ color: tags["TAGID"] === value ? "#18cc69" : "#9d9d9d", position: "relative", top: 7, right: -8 }} />
                                                </div>
                                                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", position: "absolute", top: 58, width: "100%" }}>
                                                    <div style={{ position: "relative", left: 15 }}>{renderTagImagee(tags["TAGID"])}</div>
                                                    <div style={{ color: "#fff", fontSize: 12, position: "relative", top: 6, right: 15 }}>{fasTagStatusRender(tags.tag_status)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                </RadioGroup>
            </FormControl>
            :
            <>
                <div className="formLabel-regular" style={{ margin: "10px 0 0px" }}>Enter FASTag EPC ID Manually*
                    <span>{
                        isFastTag &&
                        <CheckIcon style={{ color: customTheme.palette.primary.main }} />}</span>
                </div>
                <div>
                    <div className='fastagSelectForRequest' style={{ display: "flex", width: "100%" }}>
                        <MuiTextField style={{ marginRight: 10, width: "100%", height: "38px", marginTop: 9 }} label="" variant="outlined" value={rfid} onChange={onRfidInputChange} />
                        <Button variant="contained" color="secondary" onClick={getFastags} disableElevation style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", width: "100%", height: "38px", marginTop: "8px" }}>Fetch FASTag {fastagLoading && <CircularProgress color="secondary" size={25} style={{ marginLeft: "10px" }} />}</Button>
                    </div>
                    <div className="formLabel-regular" style={{ margin: "0px 0 0px", fontSize: 12 }} ><span style={{ color: "#707683", margin: 0 }}>To know your FASTag ID?</span><MuiLink style={{ textDecoration: 'none' }} href={`https://www.npci.org.in/what-we-do/netc-fastag/check-your-netc-fastag-status`} target="_blank"> Click here!</MuiLink></div>
                </div>

                {
                    rfid !== "" && renderTagImagee(rfid) &&
                    <div style={{ position: "relative", width: 250, border: "2px solid #18cc69", borderRadius: 12, margin: "15px 0px 20px 0px" }}>
                        <div style={{ backgroundImage: `url(${FasTagCard})`, color: "#fff", borderRadius: 10, left: 0, display: "flex", flexDirection: "column", height: "147px", backgroundRepeat: "no-repeat", backgroundSize: "100%" }}>
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", flex: 1, padding: "22px 18px" }}>
                            </div>
                        </div>
                        <div style={{ position: "absolute", top: 54, left: 18, display: "flex", justifyContent: "center", alignItems: "center" }}>{rfid !== "" && renderTagImagee(rfid)}</div>

                    </div>
                }
            </>
        }
    </div>;
}

function RequestStatusField(props) {
    const eventTracker = UseAnalyticsEvent()
    const classes = useStyles();
    const { record, source, queryParams } = props;

    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const refresh = useRefresh();
    //const notify = useNotify();
    const dispatch = useDispatch();

    const [allowCreate] = useState(sessionStorage.getItem("allow_rfid_create") === "1");
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    const [slotNameRequired] = useState(sessionStorage.getItem("slot_name_required") === "1");

    const [resolved, setResolved] = React.useState(queryParams && queryParams.vehicle_number && record && record.vehicle_number === queryParams.vehicle_number ? 1 : null);
    const [dialogVisible, setDialogVisible] = React.useState(queryParams && queryParams.vehicle_number && record && record.vehicle_number === queryParams.vehicle_number ? true : false);
    const [loading, setLoading] = useState(false);
    const [useFastag, setUseFastag] = useState("true");
    const [rfid, setRfid] = useState(null);

    const [paymentFailedDialog, setPaymentFailedDialog] = useState(null);
    const [amountText, setAmountText] = useState(0);
    const [months, setMonths] = useState(1);
    const [gstToggle, setGstToggle] = useState(false);
    const [gstAmount, setGstAmount] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);


    const [limitValidity, setLimitValidity] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [paymentMethod, setPaymentMethod] = useState('Self');

    const [primaryUsers, setPrimaryUsers] = useState([])
    const [primaryUser, setPrimaryUser] = useState({})
    const [showSecondaryPermit, setShowSecondaryPermit] = useState(false)

    const [chassisNumber, setChassisNumber] = useState(null)
    const [slotName, setSlotName] = useState("")

    const updateRfidPaymentStatus = async (
        transactionId,
        paymentStatus,
        remarks
    ) => {
        fetch(
            `${config.HOST_NAME}/crm/rfidData/${rfid}/payment/${transactionId}/status`,
            {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    payment_status: paymentStatus,
                    remarks: remarks,
                }),
            }
        )
    }

    const closePaymentFailedDialog = () => {
        setPaymentFailedDialog(null);
    }
    const onLimitValidityToggle = (checked) => {
        setLimitValidity(checked);
    }
    const openDialog = state => {
        setResolved(state);
        setDialogVisible(true);
        //setRfid("");
        if (record.vehicle_type === "2") {
            setUseFastag("false")
        }
        getPrimaryUsers()
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const onOptionChange = event => {
        setUseFastag(event.target.value);
        if (event.target.value === "true") setRfid(record.rfid)
        else setRfid("");
    }

    const primaryUserHandler = (e) => {
        setPrimaryUser(e.target.value)
    }

    const refreshPendingRequestCount = () => {
        fetch(`${config.HOST_NAME}/crm/v3/rfidRequests?pendingRequestsCount=true`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    dispatch({
                        type: "UPDATE_PERMIT_REQUESTS_COUNT",
                        payload: {
                            permitRequestsCount: json.data,
                        }
                    });
                }
            })
            .catch(e => { });
    };

    const handleUpdate = (event) => {
        event.preventDefault();

        let updatedRfid;
        if (resolved === 1) {
            if (rfid == null || rfid === "") {
                if (record.is_anpr_only) {
                    updatedRfid = `gen-${record.access_key_id}-${Date.now()}`
                } else {
                    notify("RFID is required", "warning");
                    return;
                }
            } else {
                updatedRfid = rfid;
            }
            if (limitValidity) {
                if (startDate == null || startDate === '') {
                    notify('Start Date is required', 'warning');
                    return;
                }

                if (amountText == null || amountText === '' || isNaN(amountText) || parseFloat(amountText) < 0) {
                    notify('Amount is required', 'warning');
                    return;
                }

                if (
                    totalAmount == null ||
                    totalAmount === '' ||
                    isNaN(totalAmount) ||
                    parseFloat(totalAmount) < 0
                ) {
                    notify('Amount is required', 'warning');
                    return;
                }

                if (paymentMethod == null || paymentMethod === '') {
                    notify('Payment Method is required', 'warning');
                    return;
                }
            }

            if (showSecondaryPermit && (primaryUser.id == null || primaryUser.id === "")) {
                notify('Select a Permit User', 'warning');
                return;
            }
        }

        if(slotNameRequired && !slotName){
            notify("Slot Name Required", "warning");
            return;
        }

        setLoading(true);
        if (resolved !== 1 || !limitValidity || paymentMethod === 'Cash' || paymentMethod === "Self") {

            let params;
            if (primaryUsers.length !== 0 && record.parking_type !== "Society" && showSecondaryPermit) {
                params = {
                    rfid: updatedRfid,
                    amount: primaryUser.amount,
                    limit_validity: primaryUser.limit_validity,
                    valid_till: primaryUser.valid_till,
                    start_date: startDate ? moment(startDate).format('YYYY-MM-DD 00:00:00') : null,
                    payment_method: primaryUser.payment_method,
                    organization_id: primaryUser.organization_id,
                    is_fastag: primaryUser.is_fastag || useFastag === 'true',
                    primary_permit_id: primaryUser.id,
                    chassis_number: chassisNumber,
                    vehicle_type: record.vehicle_type,
                    slot_name: slotName
                }
            } else {
                params = {
                    rfid: updatedRfid,
                    amount: limitValidity ? totalAmount : null,
                    limit_validity: limitValidity ? limitValidity : null,
                    valid_till: limitValidity && startDate && paymentMethod === 'Self' ? moment().utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss") : limitValidity && startDate && paymentMethod !== 'Self' ? moment(startDate).add(1, 'month').subtract(1, 'day').format('YYYY-MM-DD 23:59:59') : null,
                    start_date: startDate ? moment(startDate).format('YYYY-MM-DD 00:00:00') : null,
                    payment_method: limitValidity ? paymentMethod : null,
                    organization_id: record.organization_id ? record.organization_id : null,
                    is_fastag: record.is_fastag === 1 || useFastag === 'true',
                    chassis_number: chassisNumber,
                    vehicle_type: record.vehicle_type,
                    slot_name: slotName
                }
            }

            eventTracker("PERMIT REQUEST SECTION", `PERMIT REQUEST ${resolved === 1 ? 'ACCEPT' : 'DECLINE'}`, "User request for permit")
            fetch(`${config.HOST_NAME}/crm/v3/rfidRequests/${record.id}/${resolved === 1 ? 'accept' : 'decline'}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                },
                body: JSON.stringify(params),
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then((json) => {
                    setLoading(false)
                    if (json.success) {
                        notify(json.message, 'success');
                        refreshPendingRequestCount();
                    } else {
                        notify(json.message, 'warning');
                    }
                    refresh();
                })
                .catch((e) => {
                    setLoading(false);
                    notify('Check your internet connection', 'warning');
                })
        }
        else if (paymentMethod === 'Digital') {
            //payment process
            const params = {
                id: record.id,
                access_key_id: record.access_key_id,
                user_type: record.user_type,
                organization_id: record.user_type === 'company' ? record.organization_id : null,
                tower_name: record.user_type === "resident" ? record.society_tower_name : null,
                flat_number: record.user_type === "resident" ? record.society_flat_number : null,
                name: record.name,
                mobile: record.mobile,
                vehicle_number: record.vehicle_number,
                vehicle_type: record.vehicle_type,
                rfid: updatedRfid,
                limit_validity: limitValidity ? limitValidity : null,
                amount: limitValidity ? totalAmount : null,
                payment_method: limitValidity ? paymentMethod : null,
                valid_till: limitValidity && startDate ? moment(startDate).add(1, 'month').subtract(1, 'day').format('YYYY-MM-DD 23:59:59') : null,
                start_date: startDate ? startDate : null,
                registration_date: startDate ? startDate : null,
                is_fastag: record.is_fastag === 1 || useFastag === 'true',
                accepting_request: 'acceptingByPayment',
                chassis_number: chassisNumber
            }

            closeDialog();
            closePaymentFailedDialog();
            eventTracker("PERMIT REQUEST SECTION", `INITIATE PERMIT REQUEST PAYMENT`, "Digitally Accepting Permit Request")
            fetch(`${config.HOST_NAME}/crm/rfidData/initiateRfidPayment`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    rfid: updatedRfid,
                    amount: totalAmount,
                    access_key_id: params.access_key_id,
                    vehicle_number: record.vehicle_number
                }),
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then((json) => {
                    if (json.success) {
                        const order = json.data.order;
                        var options = {
                            description: 'Permit Charges',
                            currency: order.currency,
                            key: config.RAZOR_PAY_KEY_ID,
                            amount: order.amount,
                            name: 'ParkSmart',
                            order_id: order.id,
                            notes: {
                                rfid: updatedRfid,
                                parking_name: record.parking_name,
                            },
                            prefill: {
                                name: params.name,
                                contact: params.mobile,
                            },
                            theme: {
                                color: customTheme.palette.primary.main,
                            },
                            modal: {
                                ondismiss: () => {
                                    setLoading(false);
                                    const description = 'Payment is cancelled by user';
                                    setPaymentFailedDialog(description);
                                    updateRfidPaymentStatus(
                                        json.data.transaction_id,
                                        'CANCELLED',
                                        description
                                    )
                                },
                            },
                            handler: (checkoutData) => {
                                eventTracker("PERMIT REQUEST SECTION", "VERIFY PERMIT PAYMENT")
                                fetch(`${config.HOST_NAME}/crm/rfidData/verifyRfidPayment`, {
                                    method: 'POST',
                                    headers: {
                                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                                        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                        ...checkoutData,
                                        transaction_id: json.data.transaction_id,
                                        ...params,
                                    }),
                                })
                                    .then(response => {
                                        saveTokens(response)
                                        return response.json()
                                    })
                                    .then((json) => {
                                        setLoading(false);
                                        if (json.success) {
                                            notify('Payment Successful', 'success');
                                            refresh();
                                            refreshPendingRequestCount();
                                        } else {
                                            setPaymentFailedDialog(json.message);
                                        }
                                    })
                                    .catch((error) => {
                                        setLoading(false);
                                        setPaymentFailedDialog('Could not verify Payment');
                                    })
                            },
                        }
                        const razorpay = new window.Razorpay(options);
                        razorpay.on('payment.failed', function ({ error }) {
                            setLoading(false);
                            let description, status;
                            if (isJsonString(error.description)) {
                                const errorObj = JSON.parse(error.description)
                                if (errorObj.error) {
                                    description = errorObj.error.description;
                                    status = errorObj.error.reason;
                                } else {
                                    description = errorObj.description;
                                    status = errorObj.reason;
                                }
                            } else {
                                description = error.description;
                            }
                            eventTracker("PERMIT REQUEST SECTION", status === "payment_cancelled" ? "CANCELLED" : "FAILED", description)
                            setPaymentFailedDialog(description)
                            updateRfidPaymentStatus(
                                json.data.transaction_id,
                                status === 'payment_cancelled' ? 'CANCELLED' : 'FAILED',
                                description
                            )
                        })

                        razorpay.open();
                    } else {
                        setLoading(false);
                        notify(json.message, 'warning');
                    }
                })
                .catch((error) => {
                    console.log(error);
                    setLoading(false);
                    notify('Check your internet connection', 'warning');
                })
        }
    }

    const getPrimaryUsers = () => {
        fetch(`${config.HOST_NAME}/crm/v3/primaryUsers?commuter_user_id=${record.commuter_user_id}&access_key_id=${record.access_key_id}&vehicle_type=${record.vehicle_type}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    setPrimaryUsers(json.data)
                }
            })
            .catch(e => {
                console.log(e)
            });
    };

    React.useEffect(() => {
        setRfid(record && record.rfid ? record.rfid : "")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <Helmet>
                <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
            </Helmet>
            <div style={{ marginTop: isSmallDevice ? 5 : 0, textAlign: isSmallDevice ? "left" : "center", display: isSmallDevice || record[source] === -1 ? "flex" : "block", flex: 1, columnGap: 8 }}>
                {loading ?
                    <CircularProgress color="secondary" size={20} />
                    : (record[source] === -1 ?
                        (allowCreate && !viewOnly ? <>
                            <div onClick={() => openDialog(1)} className="iconButton-square" style={{ minWidth: 50, minHeight: 32, backgroundColor: customTheme.palette.primary.main + "29" }}><CheckIcon style={{ color: customTheme.palette.primary.main }} /></div>
                            <div onClick={() => openDialog(0)} className="iconButton-square" style={{ minWidth: 50, minHeight: 32, backgroundColor: customTheme.palette.error.main + "29" }}><CloseIcon style={{ color: customTheme.palette.error.main }} /></div>
                        </> : null)
                        : <>
                            <Typography style={{ fontWeight: "bold", color: record[source] === 1 ? customTheme.palette.primary.main : customTheme.palette.error.main }}>{record[source] === 1 ? "Accepted" : record[source] === 0 && "Declined"}</Typography>
                            {record.crm_user_id && record.crm_username && `by ${record.crm_username}`}
                        </>
                    )}

                <Portal>
                    <Dialog
                        open={!!paymentFailedDialog}
                        onClose={closePaymentFailedDialog}
                        classes={{ paper: classes.dialogPaper }}
                    >
                        <DialogTitle style={{ color: customTheme.palette.error.main }}>
                            <div style={{ fontSize: 16, textAlign: 'center' }}>
                                Payment Failed!
                            </div>
                        </DialogTitle>
                        <DialogContent
                            style={{ fontSize: 14, marginTop: 0, marginBottom: 10 }}
                        >
                            Description: {paymentFailedDialog}
                        </DialogContent>
                        <DialogActions
                            style={{ display: 'flex', justifyContent: 'space-evenly' }}
                        >
                            <Button
                                className={classes.dialogButton}
                                variant="outlined"
                                color="default"
                                onClick={closePaymentFailedDialog}
                            >
                                Cancel
                            </Button>
                            <Button
                                disableElevation
                                className={classes.dialogButton}
                                variant="contained"
                                color="secondary"
                                onClick={handleUpdate}
                            >
                                Retry
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Portal>

                <Dialog fullWidth open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.dialogPaperBig }}>
                    {resolved !== 1 || (((record.parking_type === "Society" && record.rfid) || record.is_anpr_only) && !slotNameRequired) ?
                        <DialogContent>
                            Are you sure you want to{' '}
                            <span style={{ fontWeight: 'bold' }}>
                                {resolved === 1 ? 'Accept' : 'Decline'}
                            </span>{' '}
                            this request?
                        </DialogContent>
                        :
                        <SimpleForm style={{ padding: '0 22px' }} toolbar={false}>

                            <TextInput
                                source="access_key_id"
                                defaultValue={record.access_key_id}
                                style={{ display: 'none' }}
                            />

                            <div style={{ width: '100%' }}>

                                <>
                                    <RadioGroup
                                        row
                                        value={useFastag}
                                        onChange={onOptionChange}
                                        style={{ marginTop: 20 }}
                                    >
                                        {record.vehicle_type === "4" && <FormControlLabel
                                            value="true"
                                            control={<Radio />}
                                            label="FASTag"
                                            style={{ flex: 1 }}
                                            disabled={record['vehicle_type'] !== '4'}
                                        />}
                                        <FormControlLabel
                                            value="false"
                                            control={<Radio />}
                                            label="ParkSmart Tag"
                                            style={{ flex: 1 }}
                                        />

                                    </RadioGroup>

                                    {useFastag === 'true' ? (
                                        <FastagSelectorForRequest record={record} rfid={rfid} setRfid={(val) => setRfid(val)} chassisNumber={chassisNumber} />
                                    ) : (
                                        <div style={{ marginBottom: 0 }}>
                                            <div style={{ display: "flex", justifyContent: "start", alignItems: "center", columnGap: 20 }}>
                                                <div style={{ display: 'flex', alignItems: "center" }}>
                                                    <img src={vehicleSvgs[record.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8 }} alt={record.vehicle_type_label} />
                                                    <p style={{ fontFamily: "Poppins-Medium", color: "#707683", fontSize: 15, textTransform: "uppercase" }}>{record.vehicle_number}</p>

                                                </div>

                                                {
                                                    (record.chassis_number !== null && record.chassis_number !== "") && <div style={{ display: 'flex', alignItems: "center" }}>
                                                        <p style={{ fontFamily: "Poppins-Medium", color: "#212121", fontSize: 15, marginRight: 8 }}>Chassis Number:</p>
                                                        <p style={{ fontFamily: "Poppins-Medium", color: "#707683", fontSize: 15, textTransform: "uppercase" }}>{record.chassis_number}</p>
                                                    </div>
                                                }
                                            </div>
                                            <div
                                                className="formLabel-regular"
                                                style={{ margin: '10px 0 3px' }}
                                            >
                                                RFID Tag*
                                            </div>
                                            <RaAutocompleteInput
                                                source="rfid"
                                                resourceParam="search"
                                                resourcePath="rfidInventory"
                                                filter={{ availableAtParkingFilter: record.access_key_id !== '' && record.access_key_id != null ? true : false, selectedParkingAccessKey: record.access_key_id }}
                                                label=""
                                                getOptionValue={(option) => option['rfid']}
                                                getOptionLabel={(option) =>
                                                    `${option['tag_id']} - ${option['rfid']}`
                                                }
                                                useAccessKeyId={false}
                                                onSelect={(value) => setRfid(value)}
                                                style={{ marginBottom: "20px" }}
                                            />
                                        </div>
                                    )
                                    }
                                </>


                                {/* here to add valid */}


                                {
                                    primaryUsers.length !== 0 && record.parking_type !== "Society" &&
                                    <FormControlLabel
                                        control={<Checkbox variant="primary" value={showSecondaryPermit} onChange={(e) => {
                                            setShowSecondaryPermit(e.target.checked)
                                            setLimitValidity(false)
                                        }} />}
                                        label="Select a Permit User"
                                    />
                                }
                                {
                                    primaryUsers.length !== 0 && record.parking_type !== "Society" && showSecondaryPermit && <div>
                                        <FormControl size="small" style={{ width: "210px", marginTop: "8px", minHeight: "20px" }}>
                                            <Select
                                                variant='outlined'
                                                value={primaryUser}
                                                onChange={primaryUserHandler}
                                            >
                                                {
                                                    primaryUsers.map((veh) => <MenuItem value={veh}> {veh.vehicle_type === "4" ? "4 Wheeler" : "2 Wheeler"} - {veh.vehicle_number}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </div>
                                }

                                {
                                    record && !record.chassis_number &&
                                    <>
                                        <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Chassis Number</div>
                                        <TextInput style={{}} source="chassis_number" label="" variant="outlined" value={chassisNumber}
                                            onChange={(e) => setChassisNumber(e.target.value)} />
                                    </>
                                }

                                {
                                    record && slotNameRequired &&
                                    <>
                                        <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Slot Name</div>
                                        <TextInput style={{}} source="slot_name" label="" variant="outlined" value={slotName}
                                            onChange={(e) => setSlotName(e.target.value)} />
                                    </>
                                }

                                {
                                    record.parking_type !== "Society" &&
                                    <div style={{ marginTop: 0 }}>

                                        <div className="formLabel-regular" style={{ position: 'relative', top: 3 }}>Start Date*</div>

                                        <CustomDatePicker
                                            style={{ marginTop: 7 }}
                                            startDate={startDate}
                                            setStartDate={(val) => setStartDate(val)}
                                        />

                                        {!showSecondaryPermit &&
                                            <>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        columnGap: 5,
                                                        width: '100%',
                                                    }}
                                                >
                                                    <RaCheckBoxInput
                                                        source="limit_validity"
                                                        label="Validity"
                                                        controlProps={{ color: 'primary' }}
                                                        defaultValue={limitValidity}
                                                        onChangeProps={onLimitValidityToggle}
                                                    />
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            columnGap: 8,
                                                            minWidth: 250,
                                                        }}
                                                    >
                                                        <InfoOutlinedIcon
                                                            style={{ fontSize: 20, color: '#bbb' }}
                                                        />
                                                        <div style={{ fontSize: 14, color: '#aaa' }}>
                                                            {limitValidity
                                                                ? 'Validity of this permit is limited'
                                                                : 'This permit is for unlimited period of time'}
                                                        </div>
                                                    </div>
                                                </div>

                                                {limitValidity && (
                                                    <ValidityAmountInputForRequest
                                                        accessKeyId={record.access_key_id}
                                                        vehicle_type={record.vehicle_type}
                                                        amountText={amountText}
                                                        setAmountText={(val) => setAmountText(val)}
                                                        gstToggle={gstToggle}
                                                        setGstToggle={(val) => setGstToggle(val)}
                                                        gstAmount={gstAmount}
                                                        setGstAmount={(val) => setGstAmount(val)}
                                                        months={months}
                                                        setMonths={(val) => setMonths(val)}
                                                        totalAmount={totalAmount}
                                                        setTotalAmount={(val) => setTotalAmount(val)}
                                                        paymentMethod={paymentMethod}
                                                        setPaymentMethod={(val) => setPaymentMethod(val)}
                                                    />
                                                )}
                                            </>
                                        }
                                    </div>
                                }
                                <div style={{ width: "100%", borderBottom: "1px solid #DEDEDE", marginTop: primaryUsers.length !== 0 ? "30px" : "0px" }}></div>
                            </div >
                        </SimpleForm >
                    }

                    <DialogActions style={{ padding: "22px 35px" }}>
                        <Button onClick={closeDialog} variant='contained' disableElevation style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }}>Cancel</Button>
                        <Button
                            className={resolved !== 1 ? classes.errorText : null}
                            variant='contained'
                            onClick={handleUpdate}
                            disableElevation
                            style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", color: "#FFFF", backgroundColor: resolved === 1 ? customTheme.palette.primary.main : customTheme.palette.error.main, }}
                        >
                            {resolved === 1
                                ? paymentMethod === 'Digital' && limitValidity
                                    ? 'Pay'
                                    : 'Accept'
                                : 'Decline'}
                        </Button>
                    </DialogActions>
                </Dialog >
            </div >
        </>
    );
}

const RfidRequestBulkActionButtons = (props) => {
    return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", columnGap: 1 }} >
        <BulkDeclineRequestButton label="Decline" record={{ ids: props.selectedIds }}/>
    </div>
}

function BulkDeclineRequestButton(props) {
    const { record } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));
    const refresh = useRefresh();
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const bulkDeclineHandler = (event) => {
        event.preventDefault();
        setLoading(true);
        fetch(`${config.HOST_NAME}/crm/v3/bulkDeclinePermitRequests`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ ids : record.ids })
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false);
                if (json.success) {
                    notify(json.message, "success");
                    refresh();
                } else {
                    notify(json.message, "warning");
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                notify("Check your internet connection", "warning");
            });
    };

    return (
        <div style={{ textAlign: isSmallDevice ? "left" : "center", display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>
            <RaButton label="Decline" style={{ color: customTheme.palette.error.main }} onClick={() => handleClickOpen()}><CloseIcon /></RaButton>

            <Portal>
                <Dialog open={open} onClose={handleClose} classes={{ paper: classes.dialogPaper }}>
                    <div style={{ marginLeft: 10 }}>
                        <p style={{ fontSize: 15, fontWeight: "500", color: "black" }}>Are you sure you want to <strong>Decline</strong> these Requests?</p>
                    </div>

                    <DialogActions>
                        <Button onClick={handleClose} variant='contained' disableElevation style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }}>Cancel</Button>
                        <Button
                            className={classes.errorText}
                            variant='contained'
                            onClick={bulkDeclineHandler}
                            disableElevation
                            style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", color: "#FFFF", backgroundColor: customTheme.palette.error.main }}
                        >
                            Decline {loading && <CircularProgress style={{color:"#FFF", marginLeft: 10}} size={14} />}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Portal>
        </div>
    );
}

const AntSwitch = withStyles((theme) => ({
    root: {
        width: 29,
        height: 16,
        padding: 0,
        display: 'flex',
    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        '&$checked': {
            transform: 'translateX(12px)',
            color: theme.palette.common.white,
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    thumb: {
        width: 12,
        height: 12,
        boxShadow: 'none',
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
        height: "auto",
        paddingTop: 2,
        paddingBottom: 2
    },
    checked: {},
}))(Switch);